/**
 * podravka.io
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.7.2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */


import ApiClient from "../ApiClient";
import ArticleVersionList from '../model/ArticleVersionList';
import ArticleVersionRead from '../model/ArticleVersionRead';
import ArticleVersionWrite from '../model/ArticleVersionWrite';
import BadRequestError from '../model/BadRequestError';
import BrandVersionList from '../model/BrandVersionList';
import BrandVersionRead from '../model/BrandVersionRead';
import BrandVersionWrite from '../model/BrandVersionWrite';
import CommentVersionList from '../model/CommentVersionList';
import CommentVersionRead from '../model/CommentVersionRead';
import CommentVersionWrite from '../model/CommentVersionWrite';
import FileVersionList from '../model/FileVersionList';
import FileVersionRead from '../model/FileVersionRead';
import FileVersionWrite from '../model/FileVersionWrite';
import ForbiddenError from '../model/ForbiddenError';
import ImageVersionList from '../model/ImageVersionList';
import ImageVersionRead from '../model/ImageVersionRead';
import ImageVersionWrite from '../model/ImageVersionWrite';
import IngredientVersionList from '../model/IngredientVersionList';
import IngredientVersionRead from '../model/IngredientVersionRead';
import IngredientVersionWrite from '../model/IngredientVersionWrite';
import InlineObject10 from '../model/InlineObject10';
import InlineObject11 from '../model/InlineObject11';
import InlineObject14 from '../model/InlineObject14';
import InlineObject15 from '../model/InlineObject15';
import InlineObject18 from '../model/InlineObject18';
import InlineObject2 from '../model/InlineObject2';
import InlineObject20 from '../model/InlineObject20';
import InlineObject24 from '../model/InlineObject24';
import InlineObject27 from '../model/InlineObject27';
import InlineObject3 from '../model/InlineObject3';
import InlineObject4 from '../model/InlineObject4';
import InlineObject5 from '../model/InlineObject5';
import InlineObject6 from '../model/InlineObject6';
import InlineObject9 from '../model/InlineObject9';
import NotAcceptableError from '../model/NotAcceptableError';
import NotFoundError from '../model/NotFoundError';
import ProductVersionList from '../model/ProductVersionList';
import ProductVersionRead from '../model/ProductVersionRead';
import ProductVersionWrite from '../model/ProductVersionWrite';
import RecipeVersionList from '../model/RecipeVersionList';
import RecipeVersionRead from '../model/RecipeVersionRead';
import RecipeVersionWrite from '../model/RecipeVersionWrite';
import ServiceUnavailableError from '../model/ServiceUnavailableError';
import UnauthorizedError from '../model/UnauthorizedError';
import VideoVersionList from '../model/VideoVersionList';
import VideoVersionRead from '../model/VideoVersionRead';
import VideoVersionWrite from '../model/VideoVersionWrite';

/**
* Versions service.
* @module api/VersionsApi
* @version 1.7.2
*/
export default class VersionsApi {

    /**
    * Constructs a new VersionsApi. 
    * @alias module:api/VersionsApi
    * @class
    * @param {module:ApiClient} [apiClient] Optional API client implementation to use,
    * default to {@link module:ApiClient#instance} if unspecified.
    */
    constructor(apiClient) {
        this.apiClient = apiClient || ApiClient.instance;
    }


    /**
     * Callback function to receive the result of the createArticleVersion operation.
     * @callback module:api/VersionsApi~createArticleVersionCallback
     * @param {String} error Error message, if any.
     * @param {module:model/ArticleVersionRead} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Creates a Article resource version.
     * @param {module:model/String} acceptLanguage Locale code
     * @param {String} articleId 
     * @param {module:model/ArticleVersionWrite} article Required properties are: * title  Rich-text properties are: * teaser * lead * body  For usage of extended attributes, see detailed instructions in the `[POST] /attributes/{entity}` endpoint of the `AttributeDefinition` section. 
     * @param {module:api/VersionsApi~createArticleVersionCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/ArticleVersionRead}
     */
    createArticleVersion(acceptLanguage, articleId, article, callback) {
      let postBody = article;
      // verify the required parameter 'acceptLanguage' is set
      if (acceptLanguage === undefined || acceptLanguage === null) {
        throw new Error("Missing the required parameter 'acceptLanguage' when calling createArticleVersion");
      }
      // verify the required parameter 'articleId' is set
      if (articleId === undefined || articleId === null) {
        throw new Error("Missing the required parameter 'articleId' when calling createArticleVersion");
      }
      // verify the required parameter 'article' is set
      if (article === undefined || article === null) {
        throw new Error("Missing the required parameter 'article' when calling createArticleVersion");
      }

      let pathParams = {
        'article_id': articleId
      };
      let queryParams = {
      };
      let headerParams = {
        'Accept-Language': acceptLanguage
      };
      let formParams = {
      };

      let authNames = ['oauth'];
      let contentTypes = ['application/json', 'text/html'];
      let accepts = ['application/json', 'text/html'];
      let returnType = ArticleVersionRead;
      return this.apiClient.callApi(
        '/articles/{article_id}/versions', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the createBrandVersion operation.
     * @callback module:api/VersionsApi~createBrandVersionCallback
     * @param {String} error Error message, if any.
     * @param {module:model/BrandVersionRead} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Creates a Brand resource version.
     * @param {module:model/String} acceptLanguage Locale code
     * @param {String} brandId 
     * @param {module:model/BrandVersionWrite} brand Required properties are: * name  Rich-text properties are: * lead * content  For usage of extended attributes, see detailed instructions in the `[POST] /attributes/{entity}` endpoint of the `AttributeDefinition` section. 
     * @param {module:api/VersionsApi~createBrandVersionCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/BrandVersionRead}
     */
    createBrandVersion(acceptLanguage, brandId, brand, callback) {
      let postBody = brand;
      // verify the required parameter 'acceptLanguage' is set
      if (acceptLanguage === undefined || acceptLanguage === null) {
        throw new Error("Missing the required parameter 'acceptLanguage' when calling createBrandVersion");
      }
      // verify the required parameter 'brandId' is set
      if (brandId === undefined || brandId === null) {
        throw new Error("Missing the required parameter 'brandId' when calling createBrandVersion");
      }
      // verify the required parameter 'brand' is set
      if (brand === undefined || brand === null) {
        throw new Error("Missing the required parameter 'brand' when calling createBrandVersion");
      }

      let pathParams = {
        'brand_id': brandId
      };
      let queryParams = {
      };
      let headerParams = {
        'Accept-Language': acceptLanguage
      };
      let formParams = {
      };

      let authNames = ['oauth'];
      let contentTypes = ['application/json', 'text/html'];
      let accepts = ['application/json', 'text/html'];
      let returnType = BrandVersionRead;
      return this.apiClient.callApi(
        '/brands/{brand_id}/versions', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the createCommentVersionForArticle operation.
     * @callback module:api/VersionsApi~createCommentVersionForArticleCallback
     * @param {String} error Error message, if any.
     * @param {module:model/CommentVersionRead} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Creates a Comment resource version. For Article.
     * @param {module:model/String} acceptLanguage Locale code
     * @param {String} articleId 
     * @param {String} commentId 
     * @param {module:model/CommentVersionWrite} comment The new Comment resource
     * @param {module:api/VersionsApi~createCommentVersionForArticleCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/CommentVersionRead}
     */
    createCommentVersionForArticle(acceptLanguage, articleId, commentId, comment, callback) {
      let postBody = comment;
      // verify the required parameter 'acceptLanguage' is set
      if (acceptLanguage === undefined || acceptLanguage === null) {
        throw new Error("Missing the required parameter 'acceptLanguage' when calling createCommentVersionForArticle");
      }
      // verify the required parameter 'articleId' is set
      if (articleId === undefined || articleId === null) {
        throw new Error("Missing the required parameter 'articleId' when calling createCommentVersionForArticle");
      }
      // verify the required parameter 'commentId' is set
      if (commentId === undefined || commentId === null) {
        throw new Error("Missing the required parameter 'commentId' when calling createCommentVersionForArticle");
      }
      // verify the required parameter 'comment' is set
      if (comment === undefined || comment === null) {
        throw new Error("Missing the required parameter 'comment' when calling createCommentVersionForArticle");
      }

      let pathParams = {
        'article_id': articleId,
        'comment_id': commentId
      };
      let queryParams = {
      };
      let headerParams = {
        'Accept-Language': acceptLanguage
      };
      let formParams = {
      };

      let authNames = ['oauth'];
      let contentTypes = ['application/json', 'text/html'];
      let accepts = ['application/json', 'text/html'];
      let returnType = CommentVersionRead;
      return this.apiClient.callApi(
        '/articles/{article_id}/comments/{comment_id}/versions', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the createCommentVersionForImage operation.
     * @callback module:api/VersionsApi~createCommentVersionForImageCallback
     * @param {String} error Error message, if any.
     * @param {module:model/CommentVersionRead} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Creates a Comment resource version. For Image.
     * @param {module:model/String} acceptLanguage Locale code
     * @param {String} imageId 
     * @param {String} commentId 
     * @param {module:model/CommentVersionWrite} comment The new Comment resource
     * @param {module:api/VersionsApi~createCommentVersionForImageCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/CommentVersionRead}
     */
    createCommentVersionForImage(acceptLanguage, imageId, commentId, comment, callback) {
      let postBody = comment;
      // verify the required parameter 'acceptLanguage' is set
      if (acceptLanguage === undefined || acceptLanguage === null) {
        throw new Error("Missing the required parameter 'acceptLanguage' when calling createCommentVersionForImage");
      }
      // verify the required parameter 'imageId' is set
      if (imageId === undefined || imageId === null) {
        throw new Error("Missing the required parameter 'imageId' when calling createCommentVersionForImage");
      }
      // verify the required parameter 'commentId' is set
      if (commentId === undefined || commentId === null) {
        throw new Error("Missing the required parameter 'commentId' when calling createCommentVersionForImage");
      }
      // verify the required parameter 'comment' is set
      if (comment === undefined || comment === null) {
        throw new Error("Missing the required parameter 'comment' when calling createCommentVersionForImage");
      }

      let pathParams = {
        'image_id': imageId,
        'comment_id': commentId
      };
      let queryParams = {
      };
      let headerParams = {
        'Accept-Language': acceptLanguage
      };
      let formParams = {
      };

      let authNames = ['oauth'];
      let contentTypes = ['application/json', 'text/html'];
      let accepts = ['application/json', 'text/html'];
      let returnType = CommentVersionRead;
      return this.apiClient.callApi(
        '/images/{image_id}/comments/{comment_id}/versions', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the createCommentVersionForProduct operation.
     * @callback module:api/VersionsApi~createCommentVersionForProductCallback
     * @param {String} error Error message, if any.
     * @param {module:model/CommentVersionRead} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Creates a Comment resource version. For Product.
     * @param {module:model/String} acceptLanguage Locale code
     * @param {String} productId 
     * @param {String} commentId 
     * @param {module:model/CommentVersionWrite} comment The new Comment resource
     * @param {module:api/VersionsApi~createCommentVersionForProductCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/CommentVersionRead}
     */
    createCommentVersionForProduct(acceptLanguage, productId, commentId, comment, callback) {
      let postBody = comment;
      // verify the required parameter 'acceptLanguage' is set
      if (acceptLanguage === undefined || acceptLanguage === null) {
        throw new Error("Missing the required parameter 'acceptLanguage' when calling createCommentVersionForProduct");
      }
      // verify the required parameter 'productId' is set
      if (productId === undefined || productId === null) {
        throw new Error("Missing the required parameter 'productId' when calling createCommentVersionForProduct");
      }
      // verify the required parameter 'commentId' is set
      if (commentId === undefined || commentId === null) {
        throw new Error("Missing the required parameter 'commentId' when calling createCommentVersionForProduct");
      }
      // verify the required parameter 'comment' is set
      if (comment === undefined || comment === null) {
        throw new Error("Missing the required parameter 'comment' when calling createCommentVersionForProduct");
      }

      let pathParams = {
        'product_id': productId,
        'comment_id': commentId
      };
      let queryParams = {
      };
      let headerParams = {
        'Accept-Language': acceptLanguage
      };
      let formParams = {
      };

      let authNames = ['oauth'];
      let contentTypes = ['application/json', 'text/html'];
      let accepts = ['application/json', 'text/html'];
      let returnType = CommentVersionRead;
      return this.apiClient.callApi(
        '/products/{product_id}/comments/{comment_id}/versions', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the createCommentVersionForRecipe operation.
     * @callback module:api/VersionsApi~createCommentVersionForRecipeCallback
     * @param {String} error Error message, if any.
     * @param {module:model/CommentVersionRead} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Creates a Comment resource version. For Recipe.
     * @param {module:model/String} acceptLanguage Locale code
     * @param {String} recipeId 
     * @param {String} commentId 
     * @param {module:model/CommentVersionWrite} comment The new Comment resource
     * @param {module:api/VersionsApi~createCommentVersionForRecipeCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/CommentVersionRead}
     */
    createCommentVersionForRecipe(acceptLanguage, recipeId, commentId, comment, callback) {
      let postBody = comment;
      // verify the required parameter 'acceptLanguage' is set
      if (acceptLanguage === undefined || acceptLanguage === null) {
        throw new Error("Missing the required parameter 'acceptLanguage' when calling createCommentVersionForRecipe");
      }
      // verify the required parameter 'recipeId' is set
      if (recipeId === undefined || recipeId === null) {
        throw new Error("Missing the required parameter 'recipeId' when calling createCommentVersionForRecipe");
      }
      // verify the required parameter 'commentId' is set
      if (commentId === undefined || commentId === null) {
        throw new Error("Missing the required parameter 'commentId' when calling createCommentVersionForRecipe");
      }
      // verify the required parameter 'comment' is set
      if (comment === undefined || comment === null) {
        throw new Error("Missing the required parameter 'comment' when calling createCommentVersionForRecipe");
      }

      let pathParams = {
        'recipe_id': recipeId,
        'comment_id': commentId
      };
      let queryParams = {
      };
      let headerParams = {
        'Accept-Language': acceptLanguage
      };
      let formParams = {
      };

      let authNames = ['oauth'];
      let contentTypes = ['application/json', 'text/html'];
      let accepts = ['application/json', 'text/html'];
      let returnType = CommentVersionRead;
      return this.apiClient.callApi(
        '/recipes/{recipe_id}/comments/{comment_id}/versions', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the createCommentVersionForTaxon operation.
     * @callback module:api/VersionsApi~createCommentVersionForTaxonCallback
     * @param {String} error Error message, if any.
     * @param {module:model/CommentVersionRead} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Creates a Comment resource version. For Taxon.
     * @param {module:model/String} acceptLanguage Locale code
     * @param {String} taxonomyName 
     * @param {String} taxonId 
     * @param {String} commentId 
     * @param {module:model/CommentVersionWrite} comment The new Comment resource
     * @param {module:api/VersionsApi~createCommentVersionForTaxonCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/CommentVersionRead}
     */
    createCommentVersionForTaxon(acceptLanguage, taxonomyName, taxonId, commentId, comment, callback) {
      let postBody = comment;
      // verify the required parameter 'acceptLanguage' is set
      if (acceptLanguage === undefined || acceptLanguage === null) {
        throw new Error("Missing the required parameter 'acceptLanguage' when calling createCommentVersionForTaxon");
      }
      // verify the required parameter 'taxonomyName' is set
      if (taxonomyName === undefined || taxonomyName === null) {
        throw new Error("Missing the required parameter 'taxonomyName' when calling createCommentVersionForTaxon");
      }
      // verify the required parameter 'taxonId' is set
      if (taxonId === undefined || taxonId === null) {
        throw new Error("Missing the required parameter 'taxonId' when calling createCommentVersionForTaxon");
      }
      // verify the required parameter 'commentId' is set
      if (commentId === undefined || commentId === null) {
        throw new Error("Missing the required parameter 'commentId' when calling createCommentVersionForTaxon");
      }
      // verify the required parameter 'comment' is set
      if (comment === undefined || comment === null) {
        throw new Error("Missing the required parameter 'comment' when calling createCommentVersionForTaxon");
      }

      let pathParams = {
        'taxonomy_name': taxonomyName,
        'taxon_id': taxonId,
        'comment_id': commentId
      };
      let queryParams = {
      };
      let headerParams = {
        'Accept-Language': acceptLanguage
      };
      let formParams = {
      };

      let authNames = ['oauth'];
      let contentTypes = ['application/json', 'text/html'];
      let accepts = ['application/json', 'text/html'];
      let returnType = CommentVersionRead;
      return this.apiClient.callApi(
        '/taxonomies/{taxonomy_name}/taxons/{taxon_id}/comments/{comment_id}/versions', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the createCommentVersionForVideo operation.
     * @callback module:api/VersionsApi~createCommentVersionForVideoCallback
     * @param {String} error Error message, if any.
     * @param {module:model/CommentVersionRead} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Creates a Comment resource version. For Video.
     * @param {module:model/String} acceptLanguage Locale code
     * @param {String} videoId 
     * @param {String} commentId 
     * @param {module:model/CommentVersionWrite} comment The new Comment resource
     * @param {module:api/VersionsApi~createCommentVersionForVideoCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/CommentVersionRead}
     */
    createCommentVersionForVideo(acceptLanguage, videoId, commentId, comment, callback) {
      let postBody = comment;
      // verify the required parameter 'acceptLanguage' is set
      if (acceptLanguage === undefined || acceptLanguage === null) {
        throw new Error("Missing the required parameter 'acceptLanguage' when calling createCommentVersionForVideo");
      }
      // verify the required parameter 'videoId' is set
      if (videoId === undefined || videoId === null) {
        throw new Error("Missing the required parameter 'videoId' when calling createCommentVersionForVideo");
      }
      // verify the required parameter 'commentId' is set
      if (commentId === undefined || commentId === null) {
        throw new Error("Missing the required parameter 'commentId' when calling createCommentVersionForVideo");
      }
      // verify the required parameter 'comment' is set
      if (comment === undefined || comment === null) {
        throw new Error("Missing the required parameter 'comment' when calling createCommentVersionForVideo");
      }

      let pathParams = {
        'video_id': videoId,
        'comment_id': commentId
      };
      let queryParams = {
      };
      let headerParams = {
        'Accept-Language': acceptLanguage
      };
      let formParams = {
      };

      let authNames = ['oauth'];
      let contentTypes = ['application/json', 'text/html'];
      let accepts = ['application/json', 'text/html'];
      let returnType = CommentVersionRead;
      return this.apiClient.callApi(
        '/videos/{video_id}/comments/{comment_id}/versions', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the createFileVersion operation.
     * @callback module:api/VersionsApi~createFileVersionCallback
     * @param {String} error Error message, if any.
     * @param {module:model/FileVersionRead} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Creates a File resource version.
     * @param {module:model/String} acceptLanguage Locale code
     * @param {String} fileId 
     * @param {module:model/FileVersionWrite} file Rich-text properties are: * description  For usage of extended attributes, see detailed instructions in the `[POST] /attributes/{entity}` endpoint of the `AttributeDefinition` section. 
     * @param {module:api/VersionsApi~createFileVersionCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/FileVersionRead}
     */
    createFileVersion(acceptLanguage, fileId, file, callback) {
      let postBody = file;
      // verify the required parameter 'acceptLanguage' is set
      if (acceptLanguage === undefined || acceptLanguage === null) {
        throw new Error("Missing the required parameter 'acceptLanguage' when calling createFileVersion");
      }
      // verify the required parameter 'fileId' is set
      if (fileId === undefined || fileId === null) {
        throw new Error("Missing the required parameter 'fileId' when calling createFileVersion");
      }
      // verify the required parameter 'file' is set
      if (file === undefined || file === null) {
        throw new Error("Missing the required parameter 'file' when calling createFileVersion");
      }

      let pathParams = {
        'file_id': fileId
      };
      let queryParams = {
      };
      let headerParams = {
        'Accept-Language': acceptLanguage
      };
      let formParams = {
      };

      let authNames = ['oauth'];
      let contentTypes = ['application/json', 'text/html'];
      let accepts = ['application/json', 'text/html'];
      let returnType = FileVersionRead;
      return this.apiClient.callApi(
        '/files/{file_id}/versions', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the createImageVersion operation.
     * @callback module:api/VersionsApi~createImageVersionCallback
     * @param {String} error Error message, if any.
     * @param {module:model/ImageVersionRead} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Creates a Image resource version.
     * @param {module:model/String} acceptLanguage Locale code
     * @param {String} imageId 
     * @param {module:model/ImageVersionWrite} image Rich-text properties are: * description  For usage of extended attributes, see detailed instructions in the `[POST] /attributes/{entity}` endpoint of the `AttributeDefinition` section. 
     * @param {module:api/VersionsApi~createImageVersionCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/ImageVersionRead}
     */
    createImageVersion(acceptLanguage, imageId, image, callback) {
      let postBody = image;
      // verify the required parameter 'acceptLanguage' is set
      if (acceptLanguage === undefined || acceptLanguage === null) {
        throw new Error("Missing the required parameter 'acceptLanguage' when calling createImageVersion");
      }
      // verify the required parameter 'imageId' is set
      if (imageId === undefined || imageId === null) {
        throw new Error("Missing the required parameter 'imageId' when calling createImageVersion");
      }
      // verify the required parameter 'image' is set
      if (image === undefined || image === null) {
        throw new Error("Missing the required parameter 'image' when calling createImageVersion");
      }

      let pathParams = {
        'image_id': imageId
      };
      let queryParams = {
      };
      let headerParams = {
        'Accept-Language': acceptLanguage
      };
      let formParams = {
      };

      let authNames = ['oauth'];
      let contentTypes = ['application/json', 'text/html'];
      let accepts = ['application/json', 'text/html'];
      let returnType = ImageVersionRead;
      return this.apiClient.callApi(
        '/images/{image_id}/versions', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the createIngredientVersion operation.
     * @callback module:api/VersionsApi~createIngredientVersionCallback
     * @param {String} error Error message, if any.
     * @param {module:model/IngredientVersionRead} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Creates a Ingredient resource version.
     * @param {module:model/String} acceptLanguage Locale code
     * @param {String} ingredientId 
     * @param {module:model/IngredientVersionWrite} ingredient Required properties are: * name  Rich-text properties are: * teaser * lead * content  For usage of extended attributes, see detailed instructions in the `[POST] /attributes/{entity}` endpoint of the `AttributeDefinition` section. 
     * @param {module:api/VersionsApi~createIngredientVersionCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/IngredientVersionRead}
     */
    createIngredientVersion(acceptLanguage, ingredientId, ingredient, callback) {
      let postBody = ingredient;
      // verify the required parameter 'acceptLanguage' is set
      if (acceptLanguage === undefined || acceptLanguage === null) {
        throw new Error("Missing the required parameter 'acceptLanguage' when calling createIngredientVersion");
      }
      // verify the required parameter 'ingredientId' is set
      if (ingredientId === undefined || ingredientId === null) {
        throw new Error("Missing the required parameter 'ingredientId' when calling createIngredientVersion");
      }
      // verify the required parameter 'ingredient' is set
      if (ingredient === undefined || ingredient === null) {
        throw new Error("Missing the required parameter 'ingredient' when calling createIngredientVersion");
      }

      let pathParams = {
        'ingredient_id': ingredientId
      };
      let queryParams = {
      };
      let headerParams = {
        'Accept-Language': acceptLanguage
      };
      let formParams = {
      };

      let authNames = ['oauth'];
      let contentTypes = ['application/json', 'text/html'];
      let accepts = ['application/json', 'text/html'];
      let returnType = IngredientVersionRead;
      return this.apiClient.callApi(
        '/ingredients/{ingredient_id}/versions', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the createProductVersion operation.
     * @callback module:api/VersionsApi~createProductVersionCallback
     * @param {String} error Error message, if any.
     * @param {module:model/ProductVersionRead} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Creates a Product resource version.
     * @param {module:model/String} acceptLanguage Locale code
     * @param {String} productId 
     * @param {module:model/ProductVersionWrite} product Required properties are: * title  Rich-text properties are: * lead * claim * preparation * body  For usage of extended attributes, see detailed instructions in the `[POST] /attributes/{entity}` endpoint of the `AttributeDefinition` section. 
     * @param {module:api/VersionsApi~createProductVersionCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/ProductVersionRead}
     */
    createProductVersion(acceptLanguage, productId, product, callback) {
      let postBody = product;
      // verify the required parameter 'acceptLanguage' is set
      if (acceptLanguage === undefined || acceptLanguage === null) {
        throw new Error("Missing the required parameter 'acceptLanguage' when calling createProductVersion");
      }
      // verify the required parameter 'productId' is set
      if (productId === undefined || productId === null) {
        throw new Error("Missing the required parameter 'productId' when calling createProductVersion");
      }
      // verify the required parameter 'product' is set
      if (product === undefined || product === null) {
        throw new Error("Missing the required parameter 'product' when calling createProductVersion");
      }

      let pathParams = {
        'product_id': productId
      };
      let queryParams = {
      };
      let headerParams = {
        'Accept-Language': acceptLanguage
      };
      let formParams = {
      };

      let authNames = ['oauth'];
      let contentTypes = ['application/json', 'text/html'];
      let accepts = ['application/json', 'text/html'];
      let returnType = ProductVersionRead;
      return this.apiClient.callApi(
        '/products/{product_id}/versions', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the createRecipeVersion operation.
     * @callback module:api/VersionsApi~createRecipeVersionCallback
     * @param {String} error Error message, if any.
     * @param {module:model/RecipeVersionRead} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Creates a Recipe resource version.
     * @param {module:model/String} acceptLanguage Locale code
     * @param {String} recipeId 
     * @param {module:model/RecipeVersionWrite} recipe Required properties are: * title  Rich-text properties are: * lead * advice * serving  For usage of extended attributes, see detailed instructions in the `[POST] /attributes/{entity}` endpoint of the `AttributeDefinition` section. 
     * @param {module:api/VersionsApi~createRecipeVersionCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/RecipeVersionRead}
     */
    createRecipeVersion(acceptLanguage, recipeId, recipe, callback) {
      let postBody = recipe;
      // verify the required parameter 'acceptLanguage' is set
      if (acceptLanguage === undefined || acceptLanguage === null) {
        throw new Error("Missing the required parameter 'acceptLanguage' when calling createRecipeVersion");
      }
      // verify the required parameter 'recipeId' is set
      if (recipeId === undefined || recipeId === null) {
        throw new Error("Missing the required parameter 'recipeId' when calling createRecipeVersion");
      }
      // verify the required parameter 'recipe' is set
      if (recipe === undefined || recipe === null) {
        throw new Error("Missing the required parameter 'recipe' when calling createRecipeVersion");
      }

      let pathParams = {
        'recipe_id': recipeId
      };
      let queryParams = {
      };
      let headerParams = {
        'Accept-Language': acceptLanguage
      };
      let formParams = {
      };

      let authNames = ['oauth'];
      let contentTypes = ['application/json', 'text/html'];
      let accepts = ['application/json', 'text/html'];
      let returnType = RecipeVersionRead;
      return this.apiClient.callApi(
        '/recipes/{recipe_id}/versions', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the createVideoVersion operation.
     * @callback module:api/VersionsApi~createVideoVersionCallback
     * @param {String} error Error message, if any.
     * @param {module:model/VideoVersionRead} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Creates a Video resource version.
     * @param {module:model/String} acceptLanguage Locale code
     * @param {String} videoId 
     * @param {module:model/VideoVersionWrite} video Rich-text properties are: * description  For usage of extended attributes, see detailed instructions in the `[POST] /attributes/{entity}` endpoint of the `AttributeDefinition` section. 
     * @param {module:api/VersionsApi~createVideoVersionCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/VideoVersionRead}
     */
    createVideoVersion(acceptLanguage, videoId, video, callback) {
      let postBody = video;
      // verify the required parameter 'acceptLanguage' is set
      if (acceptLanguage === undefined || acceptLanguage === null) {
        throw new Error("Missing the required parameter 'acceptLanguage' when calling createVideoVersion");
      }
      // verify the required parameter 'videoId' is set
      if (videoId === undefined || videoId === null) {
        throw new Error("Missing the required parameter 'videoId' when calling createVideoVersion");
      }
      // verify the required parameter 'video' is set
      if (video === undefined || video === null) {
        throw new Error("Missing the required parameter 'video' when calling createVideoVersion");
      }

      let pathParams = {
        'video_id': videoId
      };
      let queryParams = {
      };
      let headerParams = {
        'Accept-Language': acceptLanguage
      };
      let formParams = {
      };

      let authNames = ['oauth'];
      let contentTypes = ['application/json', 'text/html'];
      let accepts = ['application/json', 'text/html'];
      let returnType = VideoVersionRead;
      return this.apiClient.callApi(
        '/videos/{video_id}/versions', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the getArticleVersion operation.
     * @callback module:api/VersionsApi~getArticleVersionCallback
     * @param {String} error Error message, if any.
     * @param {module:model/ArticleVersionRead} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Retrieves the Article resource version.
     * @param {String} articleId 
     * @param {String} id 
     * @param {module:api/VersionsApi~getArticleVersionCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/ArticleVersionRead}
     */
    getArticleVersion(articleId, id, callback) {
      let postBody = null;
      // verify the required parameter 'articleId' is set
      if (articleId === undefined || articleId === null) {
        throw new Error("Missing the required parameter 'articleId' when calling getArticleVersion");
      }
      // verify the required parameter 'id' is set
      if (id === undefined || id === null) {
        throw new Error("Missing the required parameter 'id' when calling getArticleVersion");
      }

      let pathParams = {
        'article_id': articleId,
        'id': id
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['oauth'];
      let contentTypes = [];
      let accepts = ['application/json', 'text/html'];
      let returnType = ArticleVersionRead;
      return this.apiClient.callApi(
        '/articles/{article_id}/versions/{id}', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the getArticleVersionList operation.
     * @callback module:api/VersionsApi~getArticleVersionListCallback
     * @param {String} error Error message, if any.
     * @param {Array.<module:model/ArticleVersionList>} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Retrieves the list of Article versions.
     * @param {module:model/String} acceptLanguage Locale code
     * @param {String} articleId 
     * @param {Object} opts Optional parameters
     * @param {Number} opts.page The list page number
     * @param {module:api/VersionsApi~getArticleVersionListCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link Array.<module:model/ArticleVersionList>}
     */
    getArticleVersionList(acceptLanguage, articleId, opts, callback) {
      opts = opts || {};
      let postBody = null;
      // verify the required parameter 'acceptLanguage' is set
      if (acceptLanguage === undefined || acceptLanguage === null) {
        throw new Error("Missing the required parameter 'acceptLanguage' when calling getArticleVersionList");
      }
      // verify the required parameter 'articleId' is set
      if (articleId === undefined || articleId === null) {
        throw new Error("Missing the required parameter 'articleId' when calling getArticleVersionList");
      }

      let pathParams = {
        'article_id': articleId
      };
      let queryParams = {
        'page': opts['page']
      };
      let headerParams = {
        'Accept-Language': acceptLanguage
      };
      let formParams = {
      };

      let authNames = ['oauth'];
      let contentTypes = [];
      let accepts = ['application/json', 'text/html'];
      let returnType = [ArticleVersionList];
      return this.apiClient.callApi(
        '/articles/{article_id}/versions', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the getBrandVersion operation.
     * @callback module:api/VersionsApi~getBrandVersionCallback
     * @param {String} error Error message, if any.
     * @param {module:model/BrandVersionRead} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Retrieves the Brand resource version.
     * @param {String} brandId 
     * @param {String} id 
     * @param {module:api/VersionsApi~getBrandVersionCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/BrandVersionRead}
     */
    getBrandVersion(brandId, id, callback) {
      let postBody = null;
      // verify the required parameter 'brandId' is set
      if (brandId === undefined || brandId === null) {
        throw new Error("Missing the required parameter 'brandId' when calling getBrandVersion");
      }
      // verify the required parameter 'id' is set
      if (id === undefined || id === null) {
        throw new Error("Missing the required parameter 'id' when calling getBrandVersion");
      }

      let pathParams = {
        'brand_id': brandId,
        'id': id
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['oauth'];
      let contentTypes = [];
      let accepts = ['application/json', 'text/html'];
      let returnType = BrandVersionRead;
      return this.apiClient.callApi(
        '/brands/{brand_id}/versions/{id}', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the getBrandVersionList operation.
     * @callback module:api/VersionsApi~getBrandVersionListCallback
     * @param {String} error Error message, if any.
     * @param {Array.<module:model/BrandVersionList>} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Retrieves the list of Brand versions.
     * @param {module:model/String} acceptLanguage Locale code
     * @param {String} brandId 
     * @param {Object} opts Optional parameters
     * @param {Number} opts.page The list page number
     * @param {module:api/VersionsApi~getBrandVersionListCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link Array.<module:model/BrandVersionList>}
     */
    getBrandVersionList(acceptLanguage, brandId, opts, callback) {
      opts = opts || {};
      let postBody = null;
      // verify the required parameter 'acceptLanguage' is set
      if (acceptLanguage === undefined || acceptLanguage === null) {
        throw new Error("Missing the required parameter 'acceptLanguage' when calling getBrandVersionList");
      }
      // verify the required parameter 'brandId' is set
      if (brandId === undefined || brandId === null) {
        throw new Error("Missing the required parameter 'brandId' when calling getBrandVersionList");
      }

      let pathParams = {
        'brand_id': brandId
      };
      let queryParams = {
        'page': opts['page']
      };
      let headerParams = {
        'Accept-Language': acceptLanguage
      };
      let formParams = {
      };

      let authNames = ['oauth'];
      let contentTypes = [];
      let accepts = ['application/json', 'text/html'];
      let returnType = [BrandVersionList];
      return this.apiClient.callApi(
        '/brands/{brand_id}/versions', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the getCommentVersionForArticle operation.
     * @callback module:api/VersionsApi~getCommentVersionForArticleCallback
     * @param {String} error Error message, if any.
     * @param {module:model/CommentVersionRead} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Retrieves the Comment resource version. For Article.
     * @param {String} commentId 
     * @param {String} articleId 
     * @param {String} id 
     * @param {module:api/VersionsApi~getCommentVersionForArticleCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/CommentVersionRead}
     */
    getCommentVersionForArticle(commentId, articleId, id, callback) {
      let postBody = null;
      // verify the required parameter 'commentId' is set
      if (commentId === undefined || commentId === null) {
        throw new Error("Missing the required parameter 'commentId' when calling getCommentVersionForArticle");
      }
      // verify the required parameter 'articleId' is set
      if (articleId === undefined || articleId === null) {
        throw new Error("Missing the required parameter 'articleId' when calling getCommentVersionForArticle");
      }
      // verify the required parameter 'id' is set
      if (id === undefined || id === null) {
        throw new Error("Missing the required parameter 'id' when calling getCommentVersionForArticle");
      }

      let pathParams = {
        'comment_id': commentId,
        'article_id': articleId,
        'id': id
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['oauth'];
      let contentTypes = [];
      let accepts = ['application/json', 'text/html'];
      let returnType = CommentVersionRead;
      return this.apiClient.callApi(
        '/articles/{article_id}/comments/{comment_id}/versions/{id}', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the getCommentVersionForImage operation.
     * @callback module:api/VersionsApi~getCommentVersionForImageCallback
     * @param {String} error Error message, if any.
     * @param {module:model/CommentVersionRead} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Retrieves the Comment resource version. For Image.
     * @param {String} commentId 
     * @param {String} imageId 
     * @param {String} id 
     * @param {module:api/VersionsApi~getCommentVersionForImageCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/CommentVersionRead}
     */
    getCommentVersionForImage(commentId, imageId, id, callback) {
      let postBody = null;
      // verify the required parameter 'commentId' is set
      if (commentId === undefined || commentId === null) {
        throw new Error("Missing the required parameter 'commentId' when calling getCommentVersionForImage");
      }
      // verify the required parameter 'imageId' is set
      if (imageId === undefined || imageId === null) {
        throw new Error("Missing the required parameter 'imageId' when calling getCommentVersionForImage");
      }
      // verify the required parameter 'id' is set
      if (id === undefined || id === null) {
        throw new Error("Missing the required parameter 'id' when calling getCommentVersionForImage");
      }

      let pathParams = {
        'comment_id': commentId,
        'image_id': imageId,
        'id': id
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['oauth'];
      let contentTypes = [];
      let accepts = ['application/json', 'text/html'];
      let returnType = CommentVersionRead;
      return this.apiClient.callApi(
        '/images/{image_id}/comments/{comment_id}/versions/{id}', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the getCommentVersionForProduct operation.
     * @callback module:api/VersionsApi~getCommentVersionForProductCallback
     * @param {String} error Error message, if any.
     * @param {module:model/CommentVersionRead} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Retrieves the Comment resource version. For Product.
     * @param {String} commentId 
     * @param {String} productId 
     * @param {String} id 
     * @param {module:api/VersionsApi~getCommentVersionForProductCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/CommentVersionRead}
     */
    getCommentVersionForProduct(commentId, productId, id, callback) {
      let postBody = null;
      // verify the required parameter 'commentId' is set
      if (commentId === undefined || commentId === null) {
        throw new Error("Missing the required parameter 'commentId' when calling getCommentVersionForProduct");
      }
      // verify the required parameter 'productId' is set
      if (productId === undefined || productId === null) {
        throw new Error("Missing the required parameter 'productId' when calling getCommentVersionForProduct");
      }
      // verify the required parameter 'id' is set
      if (id === undefined || id === null) {
        throw new Error("Missing the required parameter 'id' when calling getCommentVersionForProduct");
      }

      let pathParams = {
        'comment_id': commentId,
        'product_id': productId,
        'id': id
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['oauth'];
      let contentTypes = [];
      let accepts = ['application/json', 'text/html'];
      let returnType = CommentVersionRead;
      return this.apiClient.callApi(
        '/products/{product_id}/comments/{comment_id}/versions/{id}', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the getCommentVersionForRecipe operation.
     * @callback module:api/VersionsApi~getCommentVersionForRecipeCallback
     * @param {String} error Error message, if any.
     * @param {module:model/CommentVersionRead} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Retrieves the Comment resource version. For Recipe.
     * @param {String} commentId 
     * @param {String} recipeId 
     * @param {String} id 
     * @param {module:api/VersionsApi~getCommentVersionForRecipeCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/CommentVersionRead}
     */
    getCommentVersionForRecipe(commentId, recipeId, id, callback) {
      let postBody = null;
      // verify the required parameter 'commentId' is set
      if (commentId === undefined || commentId === null) {
        throw new Error("Missing the required parameter 'commentId' when calling getCommentVersionForRecipe");
      }
      // verify the required parameter 'recipeId' is set
      if (recipeId === undefined || recipeId === null) {
        throw new Error("Missing the required parameter 'recipeId' when calling getCommentVersionForRecipe");
      }
      // verify the required parameter 'id' is set
      if (id === undefined || id === null) {
        throw new Error("Missing the required parameter 'id' when calling getCommentVersionForRecipe");
      }

      let pathParams = {
        'comment_id': commentId,
        'recipe_id': recipeId,
        'id': id
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['oauth'];
      let contentTypes = [];
      let accepts = ['application/json', 'text/html'];
      let returnType = CommentVersionRead;
      return this.apiClient.callApi(
        '/recipes/{recipe_id}/comments/{comment_id}/versions/{id}', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the getCommentVersionForTaxon operation.
     * @callback module:api/VersionsApi~getCommentVersionForTaxonCallback
     * @param {String} error Error message, if any.
     * @param {module:model/CommentVersionRead} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Retrieves the Comment resource version. For Taxon.
     * @param {String} commentId 
     * @param {String} taxonomyName 
     * @param {String} taxonId 
     * @param {String} id 
     * @param {module:api/VersionsApi~getCommentVersionForTaxonCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/CommentVersionRead}
     */
    getCommentVersionForTaxon(commentId, taxonomyName, taxonId, id, callback) {
      let postBody = null;
      // verify the required parameter 'commentId' is set
      if (commentId === undefined || commentId === null) {
        throw new Error("Missing the required parameter 'commentId' when calling getCommentVersionForTaxon");
      }
      // verify the required parameter 'taxonomyName' is set
      if (taxonomyName === undefined || taxonomyName === null) {
        throw new Error("Missing the required parameter 'taxonomyName' when calling getCommentVersionForTaxon");
      }
      // verify the required parameter 'taxonId' is set
      if (taxonId === undefined || taxonId === null) {
        throw new Error("Missing the required parameter 'taxonId' when calling getCommentVersionForTaxon");
      }
      // verify the required parameter 'id' is set
      if (id === undefined || id === null) {
        throw new Error("Missing the required parameter 'id' when calling getCommentVersionForTaxon");
      }

      let pathParams = {
        'comment_id': commentId,
        'taxonomy_name': taxonomyName,
        'taxon_id': taxonId,
        'id': id
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['oauth'];
      let contentTypes = [];
      let accepts = ['application/json', 'text/html'];
      let returnType = CommentVersionRead;
      return this.apiClient.callApi(
        '/taxonomies/{taxonomy_name}/taxons/{taxon_id}/comments/{comment_id}/versions/{id}', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the getCommentVersionForVideo operation.
     * @callback module:api/VersionsApi~getCommentVersionForVideoCallback
     * @param {String} error Error message, if any.
     * @param {module:model/CommentVersionRead} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Retrieves the Comment resource version. For Video.
     * @param {String} commentId 
     * @param {String} videoId 
     * @param {String} id 
     * @param {module:api/VersionsApi~getCommentVersionForVideoCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/CommentVersionRead}
     */
    getCommentVersionForVideo(commentId, videoId, id, callback) {
      let postBody = null;
      // verify the required parameter 'commentId' is set
      if (commentId === undefined || commentId === null) {
        throw new Error("Missing the required parameter 'commentId' when calling getCommentVersionForVideo");
      }
      // verify the required parameter 'videoId' is set
      if (videoId === undefined || videoId === null) {
        throw new Error("Missing the required parameter 'videoId' when calling getCommentVersionForVideo");
      }
      // verify the required parameter 'id' is set
      if (id === undefined || id === null) {
        throw new Error("Missing the required parameter 'id' when calling getCommentVersionForVideo");
      }

      let pathParams = {
        'comment_id': commentId,
        'video_id': videoId,
        'id': id
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['oauth'];
      let contentTypes = [];
      let accepts = ['application/json', 'text/html'];
      let returnType = CommentVersionRead;
      return this.apiClient.callApi(
        '/videos/{video_id}/comments/{comment_id}/versions/{id}', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the getCommentVersionListForArticle operation.
     * @callback module:api/VersionsApi~getCommentVersionListForArticleCallback
     * @param {String} error Error message, if any.
     * @param {Array.<module:model/CommentVersionList>} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Retrieves the list of Comment versions. For Article.
     * @param {module:model/String} acceptLanguage Locale code
     * @param {String} articleId 
     * @param {String} commentId 
     * @param {Object} opts Optional parameters
     * @param {Number} opts.page The list page number
     * @param {module:api/VersionsApi~getCommentVersionListForArticleCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link Array.<module:model/CommentVersionList>}
     */
    getCommentVersionListForArticle(acceptLanguage, articleId, commentId, opts, callback) {
      opts = opts || {};
      let postBody = null;
      // verify the required parameter 'acceptLanguage' is set
      if (acceptLanguage === undefined || acceptLanguage === null) {
        throw new Error("Missing the required parameter 'acceptLanguage' when calling getCommentVersionListForArticle");
      }
      // verify the required parameter 'articleId' is set
      if (articleId === undefined || articleId === null) {
        throw new Error("Missing the required parameter 'articleId' when calling getCommentVersionListForArticle");
      }
      // verify the required parameter 'commentId' is set
      if (commentId === undefined || commentId === null) {
        throw new Error("Missing the required parameter 'commentId' when calling getCommentVersionListForArticle");
      }

      let pathParams = {
        'article_id': articleId,
        'comment_id': commentId
      };
      let queryParams = {
        'page': opts['page']
      };
      let headerParams = {
        'Accept-Language': acceptLanguage
      };
      let formParams = {
      };

      let authNames = ['oauth'];
      let contentTypes = [];
      let accepts = ['application/json', 'text/html'];
      let returnType = [CommentVersionList];
      return this.apiClient.callApi(
        '/articles/{article_id}/comments/{comment_id}/versions', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the getCommentVersionListForImage operation.
     * @callback module:api/VersionsApi~getCommentVersionListForImageCallback
     * @param {String} error Error message, if any.
     * @param {Array.<module:model/CommentVersionList>} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Retrieves the list of Comment versions. For Image.
     * @param {module:model/String} acceptLanguage Locale code
     * @param {String} imageId 
     * @param {String} commentId 
     * @param {Object} opts Optional parameters
     * @param {Number} opts.page The list page number
     * @param {module:api/VersionsApi~getCommentVersionListForImageCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link Array.<module:model/CommentVersionList>}
     */
    getCommentVersionListForImage(acceptLanguage, imageId, commentId, opts, callback) {
      opts = opts || {};
      let postBody = null;
      // verify the required parameter 'acceptLanguage' is set
      if (acceptLanguage === undefined || acceptLanguage === null) {
        throw new Error("Missing the required parameter 'acceptLanguage' when calling getCommentVersionListForImage");
      }
      // verify the required parameter 'imageId' is set
      if (imageId === undefined || imageId === null) {
        throw new Error("Missing the required parameter 'imageId' when calling getCommentVersionListForImage");
      }
      // verify the required parameter 'commentId' is set
      if (commentId === undefined || commentId === null) {
        throw new Error("Missing the required parameter 'commentId' when calling getCommentVersionListForImage");
      }

      let pathParams = {
        'image_id': imageId,
        'comment_id': commentId
      };
      let queryParams = {
        'page': opts['page']
      };
      let headerParams = {
        'Accept-Language': acceptLanguage
      };
      let formParams = {
      };

      let authNames = ['oauth'];
      let contentTypes = [];
      let accepts = ['application/json', 'text/html'];
      let returnType = [CommentVersionList];
      return this.apiClient.callApi(
        '/images/{image_id}/comments/{comment_id}/versions', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the getCommentVersionListForProduct operation.
     * @callback module:api/VersionsApi~getCommentVersionListForProductCallback
     * @param {String} error Error message, if any.
     * @param {Array.<module:model/CommentVersionList>} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Retrieves the list of Comment versions. For Product.
     * @param {module:model/String} acceptLanguage Locale code
     * @param {String} productId 
     * @param {String} commentId 
     * @param {Object} opts Optional parameters
     * @param {Number} opts.page The list page number
     * @param {module:api/VersionsApi~getCommentVersionListForProductCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link Array.<module:model/CommentVersionList>}
     */
    getCommentVersionListForProduct(acceptLanguage, productId, commentId, opts, callback) {
      opts = opts || {};
      let postBody = null;
      // verify the required parameter 'acceptLanguage' is set
      if (acceptLanguage === undefined || acceptLanguage === null) {
        throw new Error("Missing the required parameter 'acceptLanguage' when calling getCommentVersionListForProduct");
      }
      // verify the required parameter 'productId' is set
      if (productId === undefined || productId === null) {
        throw new Error("Missing the required parameter 'productId' when calling getCommentVersionListForProduct");
      }
      // verify the required parameter 'commentId' is set
      if (commentId === undefined || commentId === null) {
        throw new Error("Missing the required parameter 'commentId' when calling getCommentVersionListForProduct");
      }

      let pathParams = {
        'product_id': productId,
        'comment_id': commentId
      };
      let queryParams = {
        'page': opts['page']
      };
      let headerParams = {
        'Accept-Language': acceptLanguage
      };
      let formParams = {
      };

      let authNames = ['oauth'];
      let contentTypes = [];
      let accepts = ['application/json', 'text/html'];
      let returnType = [CommentVersionList];
      return this.apiClient.callApi(
        '/products/{product_id}/comments/{comment_id}/versions', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the getCommentVersionListForRecipe operation.
     * @callback module:api/VersionsApi~getCommentVersionListForRecipeCallback
     * @param {String} error Error message, if any.
     * @param {Array.<module:model/CommentVersionList>} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Retrieves the list of Comment versions. For Recipe.
     * @param {module:model/String} acceptLanguage Locale code
     * @param {String} recipeId 
     * @param {String} commentId 
     * @param {Object} opts Optional parameters
     * @param {Number} opts.page The list page number
     * @param {module:api/VersionsApi~getCommentVersionListForRecipeCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link Array.<module:model/CommentVersionList>}
     */
    getCommentVersionListForRecipe(acceptLanguage, recipeId, commentId, opts, callback) {
      opts = opts || {};
      let postBody = null;
      // verify the required parameter 'acceptLanguage' is set
      if (acceptLanguage === undefined || acceptLanguage === null) {
        throw new Error("Missing the required parameter 'acceptLanguage' when calling getCommentVersionListForRecipe");
      }
      // verify the required parameter 'recipeId' is set
      if (recipeId === undefined || recipeId === null) {
        throw new Error("Missing the required parameter 'recipeId' when calling getCommentVersionListForRecipe");
      }
      // verify the required parameter 'commentId' is set
      if (commentId === undefined || commentId === null) {
        throw new Error("Missing the required parameter 'commentId' when calling getCommentVersionListForRecipe");
      }

      let pathParams = {
        'recipe_id': recipeId,
        'comment_id': commentId
      };
      let queryParams = {
        'page': opts['page']
      };
      let headerParams = {
        'Accept-Language': acceptLanguage
      };
      let formParams = {
      };

      let authNames = ['oauth'];
      let contentTypes = [];
      let accepts = ['application/json', 'text/html'];
      let returnType = [CommentVersionList];
      return this.apiClient.callApi(
        '/recipes/{recipe_id}/comments/{comment_id}/versions', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the getCommentVersionListForTaxon operation.
     * @callback module:api/VersionsApi~getCommentVersionListForTaxonCallback
     * @param {String} error Error message, if any.
     * @param {Array.<module:model/CommentVersionList>} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Retrieves the list of Comment versions. For Taxon.
     * @param {module:model/String} acceptLanguage Locale code
     * @param {String} taxonomyName 
     * @param {String} taxonId 
     * @param {String} commentId 
     * @param {Object} opts Optional parameters
     * @param {Number} opts.page The list page number
     * @param {module:api/VersionsApi~getCommentVersionListForTaxonCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link Array.<module:model/CommentVersionList>}
     */
    getCommentVersionListForTaxon(acceptLanguage, taxonomyName, taxonId, commentId, opts, callback) {
      opts = opts || {};
      let postBody = null;
      // verify the required parameter 'acceptLanguage' is set
      if (acceptLanguage === undefined || acceptLanguage === null) {
        throw new Error("Missing the required parameter 'acceptLanguage' when calling getCommentVersionListForTaxon");
      }
      // verify the required parameter 'taxonomyName' is set
      if (taxonomyName === undefined || taxonomyName === null) {
        throw new Error("Missing the required parameter 'taxonomyName' when calling getCommentVersionListForTaxon");
      }
      // verify the required parameter 'taxonId' is set
      if (taxonId === undefined || taxonId === null) {
        throw new Error("Missing the required parameter 'taxonId' when calling getCommentVersionListForTaxon");
      }
      // verify the required parameter 'commentId' is set
      if (commentId === undefined || commentId === null) {
        throw new Error("Missing the required parameter 'commentId' when calling getCommentVersionListForTaxon");
      }

      let pathParams = {
        'taxonomy_name': taxonomyName,
        'taxon_id': taxonId,
        'comment_id': commentId
      };
      let queryParams = {
        'page': opts['page']
      };
      let headerParams = {
        'Accept-Language': acceptLanguage
      };
      let formParams = {
      };

      let authNames = ['oauth'];
      let contentTypes = [];
      let accepts = ['application/json', 'text/html'];
      let returnType = [CommentVersionList];
      return this.apiClient.callApi(
        '/taxonomies/{taxonomy_name}/taxons/{taxon_id}/comments/{comment_id}/versions', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the getCommentVersionListForVideo operation.
     * @callback module:api/VersionsApi~getCommentVersionListForVideoCallback
     * @param {String} error Error message, if any.
     * @param {Array.<module:model/CommentVersionList>} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Retrieves the list of Comment versions. For Video.
     * @param {module:model/String} acceptLanguage Locale code
     * @param {String} videoId 
     * @param {String} commentId 
     * @param {Object} opts Optional parameters
     * @param {Number} opts.page The list page number
     * @param {module:api/VersionsApi~getCommentVersionListForVideoCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link Array.<module:model/CommentVersionList>}
     */
    getCommentVersionListForVideo(acceptLanguage, videoId, commentId, opts, callback) {
      opts = opts || {};
      let postBody = null;
      // verify the required parameter 'acceptLanguage' is set
      if (acceptLanguage === undefined || acceptLanguage === null) {
        throw new Error("Missing the required parameter 'acceptLanguage' when calling getCommentVersionListForVideo");
      }
      // verify the required parameter 'videoId' is set
      if (videoId === undefined || videoId === null) {
        throw new Error("Missing the required parameter 'videoId' when calling getCommentVersionListForVideo");
      }
      // verify the required parameter 'commentId' is set
      if (commentId === undefined || commentId === null) {
        throw new Error("Missing the required parameter 'commentId' when calling getCommentVersionListForVideo");
      }

      let pathParams = {
        'video_id': videoId,
        'comment_id': commentId
      };
      let queryParams = {
        'page': opts['page']
      };
      let headerParams = {
        'Accept-Language': acceptLanguage
      };
      let formParams = {
      };

      let authNames = ['oauth'];
      let contentTypes = [];
      let accepts = ['application/json', 'text/html'];
      let returnType = [CommentVersionList];
      return this.apiClient.callApi(
        '/videos/{video_id}/comments/{comment_id}/versions', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the getFileVersion operation.
     * @callback module:api/VersionsApi~getFileVersionCallback
     * @param {String} error Error message, if any.
     * @param {module:model/FileVersionRead} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Retrieves the File resource version.
     * @param {String} fileId 
     * @param {String} id 
     * @param {module:api/VersionsApi~getFileVersionCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/FileVersionRead}
     */
    getFileVersion(fileId, id, callback) {
      let postBody = null;
      // verify the required parameter 'fileId' is set
      if (fileId === undefined || fileId === null) {
        throw new Error("Missing the required parameter 'fileId' when calling getFileVersion");
      }
      // verify the required parameter 'id' is set
      if (id === undefined || id === null) {
        throw new Error("Missing the required parameter 'id' when calling getFileVersion");
      }

      let pathParams = {
        'file_id': fileId,
        'id': id
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['oauth'];
      let contentTypes = [];
      let accepts = ['application/json', 'text/html'];
      let returnType = FileVersionRead;
      return this.apiClient.callApi(
        '/files/{file_id}/versions/{id}', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the getFileVersionList operation.
     * @callback module:api/VersionsApi~getFileVersionListCallback
     * @param {String} error Error message, if any.
     * @param {Array.<module:model/FileVersionList>} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Retrieves the list of File versions.
     * @param {module:model/String} acceptLanguage Locale code
     * @param {String} fileId 
     * @param {Object} opts Optional parameters
     * @param {Number} opts.page The list page number
     * @param {module:api/VersionsApi~getFileVersionListCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link Array.<module:model/FileVersionList>}
     */
    getFileVersionList(acceptLanguage, fileId, opts, callback) {
      opts = opts || {};
      let postBody = null;
      // verify the required parameter 'acceptLanguage' is set
      if (acceptLanguage === undefined || acceptLanguage === null) {
        throw new Error("Missing the required parameter 'acceptLanguage' when calling getFileVersionList");
      }
      // verify the required parameter 'fileId' is set
      if (fileId === undefined || fileId === null) {
        throw new Error("Missing the required parameter 'fileId' when calling getFileVersionList");
      }

      let pathParams = {
        'file_id': fileId
      };
      let queryParams = {
        'page': opts['page']
      };
      let headerParams = {
        'Accept-Language': acceptLanguage
      };
      let formParams = {
      };

      let authNames = ['oauth'];
      let contentTypes = [];
      let accepts = ['application/json', 'text/html'];
      let returnType = [FileVersionList];
      return this.apiClient.callApi(
        '/files/{file_id}/versions', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the getImageVersion operation.
     * @callback module:api/VersionsApi~getImageVersionCallback
     * @param {String} error Error message, if any.
     * @param {module:model/ImageVersionRead} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Retrieves the Image resource version.
     * @param {String} imageId 
     * @param {String} id 
     * @param {module:api/VersionsApi~getImageVersionCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/ImageVersionRead}
     */
    getImageVersion(imageId, id, callback) {
      let postBody = null;
      // verify the required parameter 'imageId' is set
      if (imageId === undefined || imageId === null) {
        throw new Error("Missing the required parameter 'imageId' when calling getImageVersion");
      }
      // verify the required parameter 'id' is set
      if (id === undefined || id === null) {
        throw new Error("Missing the required parameter 'id' when calling getImageVersion");
      }

      let pathParams = {
        'image_id': imageId,
        'id': id
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['oauth'];
      let contentTypes = [];
      let accepts = ['application/json', 'text/html'];
      let returnType = ImageVersionRead;
      return this.apiClient.callApi(
        '/images/{image_id}/versions/{id}', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the getImageVersionList operation.
     * @callback module:api/VersionsApi~getImageVersionListCallback
     * @param {String} error Error message, if any.
     * @param {Array.<module:model/ImageVersionList>} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Retrieves the list of Image versions.
     * @param {module:model/String} acceptLanguage Locale code
     * @param {String} imageId 
     * @param {Object} opts Optional parameters
     * @param {Number} opts.page The list page number
     * @param {module:api/VersionsApi~getImageVersionListCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link Array.<module:model/ImageVersionList>}
     */
    getImageVersionList(acceptLanguage, imageId, opts, callback) {
      opts = opts || {};
      let postBody = null;
      // verify the required parameter 'acceptLanguage' is set
      if (acceptLanguage === undefined || acceptLanguage === null) {
        throw new Error("Missing the required parameter 'acceptLanguage' when calling getImageVersionList");
      }
      // verify the required parameter 'imageId' is set
      if (imageId === undefined || imageId === null) {
        throw new Error("Missing the required parameter 'imageId' when calling getImageVersionList");
      }

      let pathParams = {
        'image_id': imageId
      };
      let queryParams = {
        'page': opts['page']
      };
      let headerParams = {
        'Accept-Language': acceptLanguage
      };
      let formParams = {
      };

      let authNames = ['oauth'];
      let contentTypes = [];
      let accepts = ['application/json', 'text/html'];
      let returnType = [ImageVersionList];
      return this.apiClient.callApi(
        '/images/{image_id}/versions', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the getIngredientVersion operation.
     * @callback module:api/VersionsApi~getIngredientVersionCallback
     * @param {String} error Error message, if any.
     * @param {module:model/IngredientVersionRead} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Retrieves the Ingredient resource version.
     * @param {String} ingredientId 
     * @param {String} id 
     * @param {module:api/VersionsApi~getIngredientVersionCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/IngredientVersionRead}
     */
    getIngredientVersion(ingredientId, id, callback) {
      let postBody = null;
      // verify the required parameter 'ingredientId' is set
      if (ingredientId === undefined || ingredientId === null) {
        throw new Error("Missing the required parameter 'ingredientId' when calling getIngredientVersion");
      }
      // verify the required parameter 'id' is set
      if (id === undefined || id === null) {
        throw new Error("Missing the required parameter 'id' when calling getIngredientVersion");
      }

      let pathParams = {
        'ingredient_id': ingredientId,
        'id': id
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['oauth'];
      let contentTypes = [];
      let accepts = ['application/json', 'text/html'];
      let returnType = IngredientVersionRead;
      return this.apiClient.callApi(
        '/ingredients/{ingredient_id}/versions/{id}', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the getIngredientVersionList operation.
     * @callback module:api/VersionsApi~getIngredientVersionListCallback
     * @param {String} error Error message, if any.
     * @param {Array.<module:model/IngredientVersionList>} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Retrieves the list of Ingredient versions.
     * @param {module:model/String} acceptLanguage Locale code
     * @param {String} ingredientId 
     * @param {Object} opts Optional parameters
     * @param {Number} opts.page The list page number
     * @param {module:api/VersionsApi~getIngredientVersionListCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link Array.<module:model/IngredientVersionList>}
     */
    getIngredientVersionList(acceptLanguage, ingredientId, opts, callback) {
      opts = opts || {};
      let postBody = null;
      // verify the required parameter 'acceptLanguage' is set
      if (acceptLanguage === undefined || acceptLanguage === null) {
        throw new Error("Missing the required parameter 'acceptLanguage' when calling getIngredientVersionList");
      }
      // verify the required parameter 'ingredientId' is set
      if (ingredientId === undefined || ingredientId === null) {
        throw new Error("Missing the required parameter 'ingredientId' when calling getIngredientVersionList");
      }

      let pathParams = {
        'ingredient_id': ingredientId
      };
      let queryParams = {
        'page': opts['page']
      };
      let headerParams = {
        'Accept-Language': acceptLanguage
      };
      let formParams = {
      };

      let authNames = ['oauth'];
      let contentTypes = [];
      let accepts = ['application/json', 'text/html'];
      let returnType = [IngredientVersionList];
      return this.apiClient.callApi(
        '/ingredients/{ingredient_id}/versions', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the getProductVersion operation.
     * @callback module:api/VersionsApi~getProductVersionCallback
     * @param {String} error Error message, if any.
     * @param {module:model/ProductVersionRead} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Retrieves the Product resource version.
     * @param {String} productId 
     * @param {String} id 
     * @param {module:api/VersionsApi~getProductVersionCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/ProductVersionRead}
     */
    getProductVersion(productId, id, callback) {
      let postBody = null;
      // verify the required parameter 'productId' is set
      if (productId === undefined || productId === null) {
        throw new Error("Missing the required parameter 'productId' when calling getProductVersion");
      }
      // verify the required parameter 'id' is set
      if (id === undefined || id === null) {
        throw new Error("Missing the required parameter 'id' when calling getProductVersion");
      }

      let pathParams = {
        'product_id': productId,
        'id': id
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['oauth'];
      let contentTypes = [];
      let accepts = ['application/json', 'text/html'];
      let returnType = ProductVersionRead;
      return this.apiClient.callApi(
        '/products/{product_id}/versions/{id}', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the getProductVersionList operation.
     * @callback module:api/VersionsApi~getProductVersionListCallback
     * @param {String} error Error message, if any.
     * @param {Array.<module:model/ProductVersionList>} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Retrieves the list of Product versions.
     * @param {module:model/String} acceptLanguage Locale code
     * @param {String} productId 
     * @param {Object} opts Optional parameters
     * @param {Number} opts.page The list page number
     * @param {module:api/VersionsApi~getProductVersionListCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link Array.<module:model/ProductVersionList>}
     */
    getProductVersionList(acceptLanguage, productId, opts, callback) {
      opts = opts || {};
      let postBody = null;
      // verify the required parameter 'acceptLanguage' is set
      if (acceptLanguage === undefined || acceptLanguage === null) {
        throw new Error("Missing the required parameter 'acceptLanguage' when calling getProductVersionList");
      }
      // verify the required parameter 'productId' is set
      if (productId === undefined || productId === null) {
        throw new Error("Missing the required parameter 'productId' when calling getProductVersionList");
      }

      let pathParams = {
        'product_id': productId
      };
      let queryParams = {
        'page': opts['page']
      };
      let headerParams = {
        'Accept-Language': acceptLanguage
      };
      let formParams = {
      };

      let authNames = ['oauth'];
      let contentTypes = [];
      let accepts = ['application/json', 'text/html'];
      let returnType = [ProductVersionList];
      return this.apiClient.callApi(
        '/products/{product_id}/versions', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the getRecipeVersion operation.
     * @callback module:api/VersionsApi~getRecipeVersionCallback
     * @param {String} error Error message, if any.
     * @param {module:model/RecipeVersionRead} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Retrieves the Recipe resource version.
     * @param {String} recipeId 
     * @param {String} id 
     * @param {module:api/VersionsApi~getRecipeVersionCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/RecipeVersionRead}
     */
    getRecipeVersion(recipeId, id, callback) {
      let postBody = null;
      // verify the required parameter 'recipeId' is set
      if (recipeId === undefined || recipeId === null) {
        throw new Error("Missing the required parameter 'recipeId' when calling getRecipeVersion");
      }
      // verify the required parameter 'id' is set
      if (id === undefined || id === null) {
        throw new Error("Missing the required parameter 'id' when calling getRecipeVersion");
      }

      let pathParams = {
        'recipe_id': recipeId,
        'id': id
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['oauth'];
      let contentTypes = [];
      let accepts = ['application/json', 'text/html'];
      let returnType = RecipeVersionRead;
      return this.apiClient.callApi(
        '/recipes/{recipe_id}/versions/{id}', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the getRecipeVersionList operation.
     * @callback module:api/VersionsApi~getRecipeVersionListCallback
     * @param {String} error Error message, if any.
     * @param {Array.<module:model/RecipeVersionList>} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Retrieves the list of Recipe versions.
     * @param {module:model/String} acceptLanguage Locale code
     * @param {String} recipeId 
     * @param {Object} opts Optional parameters
     * @param {Number} opts.page The list page number
     * @param {module:api/VersionsApi~getRecipeVersionListCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link Array.<module:model/RecipeVersionList>}
     */
    getRecipeVersionList(acceptLanguage, recipeId, opts, callback) {
      opts = opts || {};
      let postBody = null;
      // verify the required parameter 'acceptLanguage' is set
      if (acceptLanguage === undefined || acceptLanguage === null) {
        throw new Error("Missing the required parameter 'acceptLanguage' when calling getRecipeVersionList");
      }
      // verify the required parameter 'recipeId' is set
      if (recipeId === undefined || recipeId === null) {
        throw new Error("Missing the required parameter 'recipeId' when calling getRecipeVersionList");
      }

      let pathParams = {
        'recipe_id': recipeId
      };
      let queryParams = {
        'page': opts['page']
      };
      let headerParams = {
        'Accept-Language': acceptLanguage
      };
      let formParams = {
      };

      let authNames = ['oauth'];
      let contentTypes = [];
      let accepts = ['application/json', 'text/html'];
      let returnType = [RecipeVersionList];
      return this.apiClient.callApi(
        '/recipes/{recipe_id}/versions', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the getVideoVersion operation.
     * @callback module:api/VersionsApi~getVideoVersionCallback
     * @param {String} error Error message, if any.
     * @param {module:model/VideoVersionRead} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Retrieves the Video resource version.
     * @param {String} videoId 
     * @param {String} id 
     * @param {module:api/VersionsApi~getVideoVersionCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/VideoVersionRead}
     */
    getVideoVersion(videoId, id, callback) {
      let postBody = null;
      // verify the required parameter 'videoId' is set
      if (videoId === undefined || videoId === null) {
        throw new Error("Missing the required parameter 'videoId' when calling getVideoVersion");
      }
      // verify the required parameter 'id' is set
      if (id === undefined || id === null) {
        throw new Error("Missing the required parameter 'id' when calling getVideoVersion");
      }

      let pathParams = {
        'video_id': videoId,
        'id': id
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['oauth'];
      let contentTypes = [];
      let accepts = ['application/json', 'text/html'];
      let returnType = VideoVersionRead;
      return this.apiClient.callApi(
        '/videos/{video_id}/versions/{id}', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the getVideoVersionList operation.
     * @callback module:api/VersionsApi~getVideoVersionListCallback
     * @param {String} error Error message, if any.
     * @param {Array.<module:model/VideoVersionList>} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Retrieves the list of Video versions.
     * @param {module:model/String} acceptLanguage Locale code
     * @param {String} videoId 
     * @param {Object} opts Optional parameters
     * @param {Number} opts.page The list page number
     * @param {module:api/VersionsApi~getVideoVersionListCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link Array.<module:model/VideoVersionList>}
     */
    getVideoVersionList(acceptLanguage, videoId, opts, callback) {
      opts = opts || {};
      let postBody = null;
      // verify the required parameter 'acceptLanguage' is set
      if (acceptLanguage === undefined || acceptLanguage === null) {
        throw new Error("Missing the required parameter 'acceptLanguage' when calling getVideoVersionList");
      }
      // verify the required parameter 'videoId' is set
      if (videoId === undefined || videoId === null) {
        throw new Error("Missing the required parameter 'videoId' when calling getVideoVersionList");
      }

      let pathParams = {
        'video_id': videoId
      };
      let queryParams = {
        'page': opts['page']
      };
      let headerParams = {
        'Accept-Language': acceptLanguage
      };
      let formParams = {
      };

      let authNames = ['oauth'];
      let contentTypes = [];
      let accepts = ['application/json', 'text/html'];
      let returnType = [VideoVersionList];
      return this.apiClient.callApi(
        '/videos/{video_id}/versions', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the updateArticleVersion operation.
     * @callback module:api/VersionsApi~updateArticleVersionCallback
     * @param {String} error Error message, if any.
     * @param {module:model/ArticleVersionRead} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Replaces the Article resource version.
     * @param {String} articleId 
     * @param {String} id 
     * @param {module:model/ArticleVersionWrite} article Required properties are: * title  Rich-text properties are: * teaser * lead * body  For usage of extended attributes, see detailed instructions in the `[POST] /attributes/{entity}` endpoint of the `AttributeDefinition` section. 
     * @param {module:api/VersionsApi~updateArticleVersionCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/ArticleVersionRead}
     */
    updateArticleVersion(articleId, id, article, callback) {
      let postBody = article;
      // verify the required parameter 'articleId' is set
      if (articleId === undefined || articleId === null) {
        throw new Error("Missing the required parameter 'articleId' when calling updateArticleVersion");
      }
      // verify the required parameter 'id' is set
      if (id === undefined || id === null) {
        throw new Error("Missing the required parameter 'id' when calling updateArticleVersion");
      }
      // verify the required parameter 'article' is set
      if (article === undefined || article === null) {
        throw new Error("Missing the required parameter 'article' when calling updateArticleVersion");
      }

      let pathParams = {
        'article_id': articleId,
        'id': id
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['oauth'];
      let contentTypes = ['application/json', 'text/html'];
      let accepts = ['application/json', 'text/html'];
      let returnType = ArticleVersionRead;
      return this.apiClient.callApi(
        '/articles/{article_id}/versions/{id}', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the updateArticleVersionOptions operation.
     * @callback module:api/VersionsApi~updateArticleVersionOptionsCallback
     * @param {String} error Error message, if any.
     * @param {module:model/ArticleVersionRead} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Updates the Article resource version options.
     * @param {String} articleId 
     * @param {String} id 
     * @param {Object} opts Optional parameters
     * @param {module:model/InlineObject3} opts.article 
     * @param {module:api/VersionsApi~updateArticleVersionOptionsCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/ArticleVersionRead}
     */
    updateArticleVersionOptions(articleId, id, opts, callback) {
      opts = opts || {};
      let postBody = opts['article'];
      // verify the required parameter 'articleId' is set
      if (articleId === undefined || articleId === null) {
        throw new Error("Missing the required parameter 'articleId' when calling updateArticleVersionOptions");
      }
      // verify the required parameter 'id' is set
      if (id === undefined || id === null) {
        throw new Error("Missing the required parameter 'id' when calling updateArticleVersionOptions");
      }

      let pathParams = {
        'article_id': articleId,
        'id': id
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['oauth'];
      let contentTypes = ['application/json', 'text/html'];
      let accepts = ['application/json', 'text/html'];
      let returnType = ArticleVersionRead;
      return this.apiClient.callApi(
        '/articles/{article_id}/versions/{id}/options', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the updateBrandVersion operation.
     * @callback module:api/VersionsApi~updateBrandVersionCallback
     * @param {String} error Error message, if any.
     * @param {module:model/BrandVersionRead} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Replaces the Brand resource version.
     * @param {String} brandId 
     * @param {String} id 
     * @param {module:model/BrandVersionWrite} brand Required properties are: * name  Rich-text properties are: * lead * content  For usage of extended attributes, see detailed instructions in the `[POST] /attributes/{entity}` endpoint of the `AttributeDefinition` section. 
     * @param {module:api/VersionsApi~updateBrandVersionCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/BrandVersionRead}
     */
    updateBrandVersion(brandId, id, brand, callback) {
      let postBody = brand;
      // verify the required parameter 'brandId' is set
      if (brandId === undefined || brandId === null) {
        throw new Error("Missing the required parameter 'brandId' when calling updateBrandVersion");
      }
      // verify the required parameter 'id' is set
      if (id === undefined || id === null) {
        throw new Error("Missing the required parameter 'id' when calling updateBrandVersion");
      }
      // verify the required parameter 'brand' is set
      if (brand === undefined || brand === null) {
        throw new Error("Missing the required parameter 'brand' when calling updateBrandVersion");
      }

      let pathParams = {
        'brand_id': brandId,
        'id': id
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['oauth'];
      let contentTypes = ['application/json', 'text/html'];
      let accepts = ['application/json', 'text/html'];
      let returnType = BrandVersionRead;
      return this.apiClient.callApi(
        '/brands/{brand_id}/versions/{id}', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the updateBrandVersionOptions operation.
     * @callback module:api/VersionsApi~updateBrandVersionOptionsCallback
     * @param {String} error Error message, if any.
     * @param {module:model/BrandVersionRead} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Updates the Brand resource version options.
     * @param {String} brandId 
     * @param {String} id 
     * @param {Object} opts Optional parameters
     * @param {module:model/InlineObject4} opts.brand 
     * @param {module:api/VersionsApi~updateBrandVersionOptionsCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/BrandVersionRead}
     */
    updateBrandVersionOptions(brandId, id, opts, callback) {
      opts = opts || {};
      let postBody = opts['brand'];
      // verify the required parameter 'brandId' is set
      if (brandId === undefined || brandId === null) {
        throw new Error("Missing the required parameter 'brandId' when calling updateBrandVersionOptions");
      }
      // verify the required parameter 'id' is set
      if (id === undefined || id === null) {
        throw new Error("Missing the required parameter 'id' when calling updateBrandVersionOptions");
      }

      let pathParams = {
        'brand_id': brandId,
        'id': id
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['oauth'];
      let contentTypes = ['application/json', 'text/html'];
      let accepts = ['application/json', 'text/html'];
      let returnType = BrandVersionRead;
      return this.apiClient.callApi(
        '/brands/{brand_id}/versions/{id}/options', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the updateCommentVersionForArticle operation.
     * @callback module:api/VersionsApi~updateCommentVersionForArticleCallback
     * @param {String} error Error message, if any.
     * @param {module:model/CommentVersionRead} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Replaces the Comment resource version. For Article.
     * @param {String} commentId 
     * @param {String} articleId 
     * @param {String} id 
     * @param {module:model/CommentVersionWrite} comment The updated Comment resource
     * @param {module:api/VersionsApi~updateCommentVersionForArticleCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/CommentVersionRead}
     */
    updateCommentVersionForArticle(commentId, articleId, id, comment, callback) {
      let postBody = comment;
      // verify the required parameter 'commentId' is set
      if (commentId === undefined || commentId === null) {
        throw new Error("Missing the required parameter 'commentId' when calling updateCommentVersionForArticle");
      }
      // verify the required parameter 'articleId' is set
      if (articleId === undefined || articleId === null) {
        throw new Error("Missing the required parameter 'articleId' when calling updateCommentVersionForArticle");
      }
      // verify the required parameter 'id' is set
      if (id === undefined || id === null) {
        throw new Error("Missing the required parameter 'id' when calling updateCommentVersionForArticle");
      }
      // verify the required parameter 'comment' is set
      if (comment === undefined || comment === null) {
        throw new Error("Missing the required parameter 'comment' when calling updateCommentVersionForArticle");
      }

      let pathParams = {
        'comment_id': commentId,
        'article_id': articleId,
        'id': id
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['oauth'];
      let contentTypes = ['application/json', 'text/html'];
      let accepts = ['application/json', 'text/html'];
      let returnType = CommentVersionRead;
      return this.apiClient.callApi(
        '/articles/{article_id}/comments/{comment_id}/versions/{id}', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the updateCommentVersionForImage operation.
     * @callback module:api/VersionsApi~updateCommentVersionForImageCallback
     * @param {String} error Error message, if any.
     * @param {module:model/CommentVersionRead} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Replaces the Comment resource version. For Image.
     * @param {String} commentId 
     * @param {String} imageId 
     * @param {String} id 
     * @param {module:model/CommentVersionWrite} comment The updated Comment resource
     * @param {module:api/VersionsApi~updateCommentVersionForImageCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/CommentVersionRead}
     */
    updateCommentVersionForImage(commentId, imageId, id, comment, callback) {
      let postBody = comment;
      // verify the required parameter 'commentId' is set
      if (commentId === undefined || commentId === null) {
        throw new Error("Missing the required parameter 'commentId' when calling updateCommentVersionForImage");
      }
      // verify the required parameter 'imageId' is set
      if (imageId === undefined || imageId === null) {
        throw new Error("Missing the required parameter 'imageId' when calling updateCommentVersionForImage");
      }
      // verify the required parameter 'id' is set
      if (id === undefined || id === null) {
        throw new Error("Missing the required parameter 'id' when calling updateCommentVersionForImage");
      }
      // verify the required parameter 'comment' is set
      if (comment === undefined || comment === null) {
        throw new Error("Missing the required parameter 'comment' when calling updateCommentVersionForImage");
      }

      let pathParams = {
        'comment_id': commentId,
        'image_id': imageId,
        'id': id
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['oauth'];
      let contentTypes = ['application/json', 'text/html'];
      let accepts = ['application/json', 'text/html'];
      let returnType = CommentVersionRead;
      return this.apiClient.callApi(
        '/images/{image_id}/comments/{comment_id}/versions/{id}', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the updateCommentVersionForProduct operation.
     * @callback module:api/VersionsApi~updateCommentVersionForProductCallback
     * @param {String} error Error message, if any.
     * @param {module:model/CommentVersionRead} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Replaces the Comment resource version. For Product.
     * @param {String} commentId 
     * @param {String} productId 
     * @param {String} id 
     * @param {module:model/CommentVersionWrite} comment The updated Comment resource
     * @param {module:api/VersionsApi~updateCommentVersionForProductCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/CommentVersionRead}
     */
    updateCommentVersionForProduct(commentId, productId, id, comment, callback) {
      let postBody = comment;
      // verify the required parameter 'commentId' is set
      if (commentId === undefined || commentId === null) {
        throw new Error("Missing the required parameter 'commentId' when calling updateCommentVersionForProduct");
      }
      // verify the required parameter 'productId' is set
      if (productId === undefined || productId === null) {
        throw new Error("Missing the required parameter 'productId' when calling updateCommentVersionForProduct");
      }
      // verify the required parameter 'id' is set
      if (id === undefined || id === null) {
        throw new Error("Missing the required parameter 'id' when calling updateCommentVersionForProduct");
      }
      // verify the required parameter 'comment' is set
      if (comment === undefined || comment === null) {
        throw new Error("Missing the required parameter 'comment' when calling updateCommentVersionForProduct");
      }

      let pathParams = {
        'comment_id': commentId,
        'product_id': productId,
        'id': id
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['oauth'];
      let contentTypes = ['application/json', 'text/html'];
      let accepts = ['application/json', 'text/html'];
      let returnType = CommentVersionRead;
      return this.apiClient.callApi(
        '/products/{product_id}/comments/{comment_id}/versions/{id}', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the updateCommentVersionForRecipe operation.
     * @callback module:api/VersionsApi~updateCommentVersionForRecipeCallback
     * @param {String} error Error message, if any.
     * @param {module:model/CommentVersionRead} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Replaces the Comment resource version. For Recipe.
     * @param {String} commentId 
     * @param {String} recipeId 
     * @param {String} id 
     * @param {module:model/CommentVersionWrite} comment The updated Comment resource
     * @param {module:api/VersionsApi~updateCommentVersionForRecipeCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/CommentVersionRead}
     */
    updateCommentVersionForRecipe(commentId, recipeId, id, comment, callback) {
      let postBody = comment;
      // verify the required parameter 'commentId' is set
      if (commentId === undefined || commentId === null) {
        throw new Error("Missing the required parameter 'commentId' when calling updateCommentVersionForRecipe");
      }
      // verify the required parameter 'recipeId' is set
      if (recipeId === undefined || recipeId === null) {
        throw new Error("Missing the required parameter 'recipeId' when calling updateCommentVersionForRecipe");
      }
      // verify the required parameter 'id' is set
      if (id === undefined || id === null) {
        throw new Error("Missing the required parameter 'id' when calling updateCommentVersionForRecipe");
      }
      // verify the required parameter 'comment' is set
      if (comment === undefined || comment === null) {
        throw new Error("Missing the required parameter 'comment' when calling updateCommentVersionForRecipe");
      }

      let pathParams = {
        'comment_id': commentId,
        'recipe_id': recipeId,
        'id': id
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['oauth'];
      let contentTypes = ['application/json', 'text/html'];
      let accepts = ['application/json', 'text/html'];
      let returnType = CommentVersionRead;
      return this.apiClient.callApi(
        '/recipes/{recipe_id}/comments/{comment_id}/versions/{id}', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the updateCommentVersionForTaxon operation.
     * @callback module:api/VersionsApi~updateCommentVersionForTaxonCallback
     * @param {String} error Error message, if any.
     * @param {module:model/CommentVersionRead} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Replaces the Comment resource version. For Taxon.
     * @param {String} commentId 
     * @param {String} taxonomyName 
     * @param {String} taxonId 
     * @param {String} id 
     * @param {module:model/CommentVersionWrite} comment The updated Comment resource
     * @param {module:api/VersionsApi~updateCommentVersionForTaxonCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/CommentVersionRead}
     */
    updateCommentVersionForTaxon(commentId, taxonomyName, taxonId, id, comment, callback) {
      let postBody = comment;
      // verify the required parameter 'commentId' is set
      if (commentId === undefined || commentId === null) {
        throw new Error("Missing the required parameter 'commentId' when calling updateCommentVersionForTaxon");
      }
      // verify the required parameter 'taxonomyName' is set
      if (taxonomyName === undefined || taxonomyName === null) {
        throw new Error("Missing the required parameter 'taxonomyName' when calling updateCommentVersionForTaxon");
      }
      // verify the required parameter 'taxonId' is set
      if (taxonId === undefined || taxonId === null) {
        throw new Error("Missing the required parameter 'taxonId' when calling updateCommentVersionForTaxon");
      }
      // verify the required parameter 'id' is set
      if (id === undefined || id === null) {
        throw new Error("Missing the required parameter 'id' when calling updateCommentVersionForTaxon");
      }
      // verify the required parameter 'comment' is set
      if (comment === undefined || comment === null) {
        throw new Error("Missing the required parameter 'comment' when calling updateCommentVersionForTaxon");
      }

      let pathParams = {
        'comment_id': commentId,
        'taxonomy_name': taxonomyName,
        'taxon_id': taxonId,
        'id': id
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['oauth'];
      let contentTypes = ['application/json', 'text/html'];
      let accepts = ['application/json', 'text/html'];
      let returnType = CommentVersionRead;
      return this.apiClient.callApi(
        '/taxonomies/{taxonomy_name}/taxons/{taxon_id}/comments/{comment_id}/versions/{id}', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the updateCommentVersionForVideo operation.
     * @callback module:api/VersionsApi~updateCommentVersionForVideoCallback
     * @param {String} error Error message, if any.
     * @param {module:model/CommentVersionRead} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Replaces the Comment resource version. For Video.
     * @param {String} commentId 
     * @param {String} videoId 
     * @param {String} id 
     * @param {module:model/CommentVersionWrite} comment The updated Comment resource
     * @param {module:api/VersionsApi~updateCommentVersionForVideoCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/CommentVersionRead}
     */
    updateCommentVersionForVideo(commentId, videoId, id, comment, callback) {
      let postBody = comment;
      // verify the required parameter 'commentId' is set
      if (commentId === undefined || commentId === null) {
        throw new Error("Missing the required parameter 'commentId' when calling updateCommentVersionForVideo");
      }
      // verify the required parameter 'videoId' is set
      if (videoId === undefined || videoId === null) {
        throw new Error("Missing the required parameter 'videoId' when calling updateCommentVersionForVideo");
      }
      // verify the required parameter 'id' is set
      if (id === undefined || id === null) {
        throw new Error("Missing the required parameter 'id' when calling updateCommentVersionForVideo");
      }
      // verify the required parameter 'comment' is set
      if (comment === undefined || comment === null) {
        throw new Error("Missing the required parameter 'comment' when calling updateCommentVersionForVideo");
      }

      let pathParams = {
        'comment_id': commentId,
        'video_id': videoId,
        'id': id
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['oauth'];
      let contentTypes = ['application/json', 'text/html'];
      let accepts = ['application/json', 'text/html'];
      let returnType = CommentVersionRead;
      return this.apiClient.callApi(
        '/videos/{video_id}/comments/{comment_id}/versions/{id}', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the updateCommentVersionOptionsForArticle operation.
     * @callback module:api/VersionsApi~updateCommentVersionOptionsForArticleCallback
     * @param {String} error Error message, if any.
     * @param {module:model/CommentVersionRead} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Updates the Comment resource version options. For Article.
     * @param {String} commentId 
     * @param {String} articleId 
     * @param {String} id 
     * @param {Object} opts Optional parameters
     * @param {module:model/InlineObject2} opts.comment 
     * @param {module:api/VersionsApi~updateCommentVersionOptionsForArticleCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/CommentVersionRead}
     */
    updateCommentVersionOptionsForArticle(commentId, articleId, id, opts, callback) {
      opts = opts || {};
      let postBody = opts['comment'];
      // verify the required parameter 'commentId' is set
      if (commentId === undefined || commentId === null) {
        throw new Error("Missing the required parameter 'commentId' when calling updateCommentVersionOptionsForArticle");
      }
      // verify the required parameter 'articleId' is set
      if (articleId === undefined || articleId === null) {
        throw new Error("Missing the required parameter 'articleId' when calling updateCommentVersionOptionsForArticle");
      }
      // verify the required parameter 'id' is set
      if (id === undefined || id === null) {
        throw new Error("Missing the required parameter 'id' when calling updateCommentVersionOptionsForArticle");
      }

      let pathParams = {
        'comment_id': commentId,
        'article_id': articleId,
        'id': id
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['oauth'];
      let contentTypes = ['application/json', 'text/html'];
      let accepts = ['application/json', 'text/html'];
      let returnType = CommentVersionRead;
      return this.apiClient.callApi(
        '/articles/{article_id}/comments/{comment_id}/versions/{id}/options', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the updateCommentVersionOptionsForImage operation.
     * @callback module:api/VersionsApi~updateCommentVersionOptionsForImageCallback
     * @param {String} error Error message, if any.
     * @param {module:model/CommentVersionRead} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Updates the Comment resource version options. For Image.
     * @param {String} commentId 
     * @param {String} imageId 
     * @param {String} id 
     * @param {Object} opts Optional parameters
     * @param {module:model/InlineObject6} opts.comment 
     * @param {module:api/VersionsApi~updateCommentVersionOptionsForImageCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/CommentVersionRead}
     */
    updateCommentVersionOptionsForImage(commentId, imageId, id, opts, callback) {
      opts = opts || {};
      let postBody = opts['comment'];
      // verify the required parameter 'commentId' is set
      if (commentId === undefined || commentId === null) {
        throw new Error("Missing the required parameter 'commentId' when calling updateCommentVersionOptionsForImage");
      }
      // verify the required parameter 'imageId' is set
      if (imageId === undefined || imageId === null) {
        throw new Error("Missing the required parameter 'imageId' when calling updateCommentVersionOptionsForImage");
      }
      // verify the required parameter 'id' is set
      if (id === undefined || id === null) {
        throw new Error("Missing the required parameter 'id' when calling updateCommentVersionOptionsForImage");
      }

      let pathParams = {
        'comment_id': commentId,
        'image_id': imageId,
        'id': id
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['oauth'];
      let contentTypes = ['application/json', 'text/html'];
      let accepts = ['application/json', 'text/html'];
      let returnType = CommentVersionRead;
      return this.apiClient.callApi(
        '/images/{image_id}/comments/{comment_id}/versions/{id}/options', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the updateCommentVersionOptionsForProduct operation.
     * @callback module:api/VersionsApi~updateCommentVersionOptionsForProductCallback
     * @param {String} error Error message, if any.
     * @param {module:model/CommentVersionRead} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Updates the Comment resource version options. For Product.
     * @param {String} commentId 
     * @param {String} productId 
     * @param {String} id 
     * @param {Object} opts Optional parameters
     * @param {module:model/InlineObject11} opts.comment 
     * @param {module:api/VersionsApi~updateCommentVersionOptionsForProductCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/CommentVersionRead}
     */
    updateCommentVersionOptionsForProduct(commentId, productId, id, opts, callback) {
      opts = opts || {};
      let postBody = opts['comment'];
      // verify the required parameter 'commentId' is set
      if (commentId === undefined || commentId === null) {
        throw new Error("Missing the required parameter 'commentId' when calling updateCommentVersionOptionsForProduct");
      }
      // verify the required parameter 'productId' is set
      if (productId === undefined || productId === null) {
        throw new Error("Missing the required parameter 'productId' when calling updateCommentVersionOptionsForProduct");
      }
      // verify the required parameter 'id' is set
      if (id === undefined || id === null) {
        throw new Error("Missing the required parameter 'id' when calling updateCommentVersionOptionsForProduct");
      }

      let pathParams = {
        'comment_id': commentId,
        'product_id': productId,
        'id': id
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['oauth'];
      let contentTypes = ['application/json', 'text/html'];
      let accepts = ['application/json', 'text/html'];
      let returnType = CommentVersionRead;
      return this.apiClient.callApi(
        '/products/{product_id}/comments/{comment_id}/versions/{id}/options', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the updateCommentVersionOptionsForRecipe operation.
     * @callback module:api/VersionsApi~updateCommentVersionOptionsForRecipeCallback
     * @param {String} error Error message, if any.
     * @param {module:model/CommentVersionRead} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Updates the Comment resource version options. For Recipe.
     * @param {String} commentId 
     * @param {String} recipeId 
     * @param {String} id 
     * @param {Object} opts Optional parameters
     * @param {module:model/InlineObject15} opts.comment 
     * @param {module:api/VersionsApi~updateCommentVersionOptionsForRecipeCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/CommentVersionRead}
     */
    updateCommentVersionOptionsForRecipe(commentId, recipeId, id, opts, callback) {
      opts = opts || {};
      let postBody = opts['comment'];
      // verify the required parameter 'commentId' is set
      if (commentId === undefined || commentId === null) {
        throw new Error("Missing the required parameter 'commentId' when calling updateCommentVersionOptionsForRecipe");
      }
      // verify the required parameter 'recipeId' is set
      if (recipeId === undefined || recipeId === null) {
        throw new Error("Missing the required parameter 'recipeId' when calling updateCommentVersionOptionsForRecipe");
      }
      // verify the required parameter 'id' is set
      if (id === undefined || id === null) {
        throw new Error("Missing the required parameter 'id' when calling updateCommentVersionOptionsForRecipe");
      }

      let pathParams = {
        'comment_id': commentId,
        'recipe_id': recipeId,
        'id': id
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['oauth'];
      let contentTypes = ['application/json', 'text/html'];
      let accepts = ['application/json', 'text/html'];
      let returnType = CommentVersionRead;
      return this.apiClient.callApi(
        '/recipes/{recipe_id}/comments/{comment_id}/versions/{id}/options', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the updateCommentVersionOptionsForTaxon operation.
     * @callback module:api/VersionsApi~updateCommentVersionOptionsForTaxonCallback
     * @param {String} error Error message, if any.
     * @param {module:model/CommentVersionRead} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Updates the Comment resource version options. For Taxon.
     * @param {String} commentId 
     * @param {String} taxonomyName 
     * @param {String} taxonId 
     * @param {String} id 
     * @param {Object} opts Optional parameters
     * @param {module:model/InlineObject20} opts.comment 
     * @param {module:api/VersionsApi~updateCommentVersionOptionsForTaxonCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/CommentVersionRead}
     */
    updateCommentVersionOptionsForTaxon(commentId, taxonomyName, taxonId, id, opts, callback) {
      opts = opts || {};
      let postBody = opts['comment'];
      // verify the required parameter 'commentId' is set
      if (commentId === undefined || commentId === null) {
        throw new Error("Missing the required parameter 'commentId' when calling updateCommentVersionOptionsForTaxon");
      }
      // verify the required parameter 'taxonomyName' is set
      if (taxonomyName === undefined || taxonomyName === null) {
        throw new Error("Missing the required parameter 'taxonomyName' when calling updateCommentVersionOptionsForTaxon");
      }
      // verify the required parameter 'taxonId' is set
      if (taxonId === undefined || taxonId === null) {
        throw new Error("Missing the required parameter 'taxonId' when calling updateCommentVersionOptionsForTaxon");
      }
      // verify the required parameter 'id' is set
      if (id === undefined || id === null) {
        throw new Error("Missing the required parameter 'id' when calling updateCommentVersionOptionsForTaxon");
      }

      let pathParams = {
        'comment_id': commentId,
        'taxonomy_name': taxonomyName,
        'taxon_id': taxonId,
        'id': id
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['oauth'];
      let contentTypes = ['application/json', 'text/html'];
      let accepts = ['application/json', 'text/html'];
      let returnType = CommentVersionRead;
      return this.apiClient.callApi(
        '/taxonomies/{taxonomy_name}/taxons/{taxon_id}/comments/{comment_id}/versions/{id}/options', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the updateCommentVersionOptionsForVideo operation.
     * @callback module:api/VersionsApi~updateCommentVersionOptionsForVideoCallback
     * @param {String} error Error message, if any.
     * @param {module:model/CommentVersionRead} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Updates the Comment resource version options. For Video.
     * @param {String} commentId 
     * @param {String} videoId 
     * @param {String} id 
     * @param {Object} opts Optional parameters
     * @param {module:model/InlineObject24} opts.comment 
     * @param {module:api/VersionsApi~updateCommentVersionOptionsForVideoCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/CommentVersionRead}
     */
    updateCommentVersionOptionsForVideo(commentId, videoId, id, opts, callback) {
      opts = opts || {};
      let postBody = opts['comment'];
      // verify the required parameter 'commentId' is set
      if (commentId === undefined || commentId === null) {
        throw new Error("Missing the required parameter 'commentId' when calling updateCommentVersionOptionsForVideo");
      }
      // verify the required parameter 'videoId' is set
      if (videoId === undefined || videoId === null) {
        throw new Error("Missing the required parameter 'videoId' when calling updateCommentVersionOptionsForVideo");
      }
      // verify the required parameter 'id' is set
      if (id === undefined || id === null) {
        throw new Error("Missing the required parameter 'id' when calling updateCommentVersionOptionsForVideo");
      }

      let pathParams = {
        'comment_id': commentId,
        'video_id': videoId,
        'id': id
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['oauth'];
      let contentTypes = ['application/json', 'text/html'];
      let accepts = ['application/json', 'text/html'];
      let returnType = CommentVersionRead;
      return this.apiClient.callApi(
        '/videos/{video_id}/comments/{comment_id}/versions/{id}/options', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the updateFileVersion operation.
     * @callback module:api/VersionsApi~updateFileVersionCallback
     * @param {String} error Error message, if any.
     * @param {module:model/FileVersionRead} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Replaces the File resource version.
     * @param {String} fileId 
     * @param {String} id 
     * @param {module:model/FileVersionWrite} file Rich-text properties are: * description  For usage of extended attributes, see detailed instructions in the `[POST] /attributes/{entity}` endpoint of the `AttributeDefinition` section. 
     * @param {module:api/VersionsApi~updateFileVersionCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/FileVersionRead}
     */
    updateFileVersion(fileId, id, file, callback) {
      let postBody = file;
      // verify the required parameter 'fileId' is set
      if (fileId === undefined || fileId === null) {
        throw new Error("Missing the required parameter 'fileId' when calling updateFileVersion");
      }
      // verify the required parameter 'id' is set
      if (id === undefined || id === null) {
        throw new Error("Missing the required parameter 'id' when calling updateFileVersion");
      }
      // verify the required parameter 'file' is set
      if (file === undefined || file === null) {
        throw new Error("Missing the required parameter 'file' when calling updateFileVersion");
      }

      let pathParams = {
        'file_id': fileId,
        'id': id
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['oauth'];
      let contentTypes = ['application/json', 'text/html'];
      let accepts = ['application/json', 'text/html'];
      let returnType = FileVersionRead;
      return this.apiClient.callApi(
        '/files/{file_id}/versions/{id}', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the updateFileVersionOptions operation.
     * @callback module:api/VersionsApi~updateFileVersionOptionsCallback
     * @param {String} error Error message, if any.
     * @param {module:model/FileVersionRead} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Updates the File resource version options.
     * @param {String} fileId 
     * @param {String} id 
     * @param {Object} opts Optional parameters
     * @param {module:model/InlineObject5} opts.file 
     * @param {module:api/VersionsApi~updateFileVersionOptionsCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/FileVersionRead}
     */
    updateFileVersionOptions(fileId, id, opts, callback) {
      opts = opts || {};
      let postBody = opts['file'];
      // verify the required parameter 'fileId' is set
      if (fileId === undefined || fileId === null) {
        throw new Error("Missing the required parameter 'fileId' when calling updateFileVersionOptions");
      }
      // verify the required parameter 'id' is set
      if (id === undefined || id === null) {
        throw new Error("Missing the required parameter 'id' when calling updateFileVersionOptions");
      }

      let pathParams = {
        'file_id': fileId,
        'id': id
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['oauth'];
      let contentTypes = ['application/json', 'text/html'];
      let accepts = ['application/json', 'text/html'];
      let returnType = FileVersionRead;
      return this.apiClient.callApi(
        '/files/{file_id}/versions/{id}/options', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the updateImageVersion operation.
     * @callback module:api/VersionsApi~updateImageVersionCallback
     * @param {String} error Error message, if any.
     * @param {module:model/ImageVersionRead} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Replaces the Image resource version.
     * @param {String} imageId 
     * @param {String} id 
     * @param {module:model/ImageVersionWrite} image Rich-text properties are: * description  For usage of extended attributes, see detailed instructions in the `[POST] /attributes/{entity}` endpoint of the `AttributeDefinition` section. 
     * @param {module:api/VersionsApi~updateImageVersionCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/ImageVersionRead}
     */
    updateImageVersion(imageId, id, image, callback) {
      let postBody = image;
      // verify the required parameter 'imageId' is set
      if (imageId === undefined || imageId === null) {
        throw new Error("Missing the required parameter 'imageId' when calling updateImageVersion");
      }
      // verify the required parameter 'id' is set
      if (id === undefined || id === null) {
        throw new Error("Missing the required parameter 'id' when calling updateImageVersion");
      }
      // verify the required parameter 'image' is set
      if (image === undefined || image === null) {
        throw new Error("Missing the required parameter 'image' when calling updateImageVersion");
      }

      let pathParams = {
        'image_id': imageId,
        'id': id
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['oauth'];
      let contentTypes = ['application/json', 'text/html'];
      let accepts = ['application/json', 'text/html'];
      let returnType = ImageVersionRead;
      return this.apiClient.callApi(
        '/images/{image_id}/versions/{id}', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the updateImageVersionOptions operation.
     * @callback module:api/VersionsApi~updateImageVersionOptionsCallback
     * @param {String} error Error message, if any.
     * @param {module:model/ImageVersionRead} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Updates the Image resource version options.
     * @param {String} imageId 
     * @param {String} id 
     * @param {Object} opts Optional parameters
     * @param {module:model/InlineObject9} opts.image 
     * @param {module:api/VersionsApi~updateImageVersionOptionsCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/ImageVersionRead}
     */
    updateImageVersionOptions(imageId, id, opts, callback) {
      opts = opts || {};
      let postBody = opts['image'];
      // verify the required parameter 'imageId' is set
      if (imageId === undefined || imageId === null) {
        throw new Error("Missing the required parameter 'imageId' when calling updateImageVersionOptions");
      }
      // verify the required parameter 'id' is set
      if (id === undefined || id === null) {
        throw new Error("Missing the required parameter 'id' when calling updateImageVersionOptions");
      }

      let pathParams = {
        'image_id': imageId,
        'id': id
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['oauth'];
      let contentTypes = ['application/json', 'text/html'];
      let accepts = ['application/json', 'text/html'];
      let returnType = ImageVersionRead;
      return this.apiClient.callApi(
        '/images/{image_id}/versions/{id}/options', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the updateIngredientVersion operation.
     * @callback module:api/VersionsApi~updateIngredientVersionCallback
     * @param {String} error Error message, if any.
     * @param {module:model/IngredientVersionRead} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Replaces the Ingredient resource version.
     * @param {String} ingredientId 
     * @param {String} id 
     * @param {module:model/IngredientVersionWrite} ingredient Required properties are: * name  Rich-text properties are: * teaser * lead * content  For usage of extended attributes, see detailed instructions in the `[POST] /attributes/{entity}` endpoint of the `AttributeDefinition` section. 
     * @param {module:api/VersionsApi~updateIngredientVersionCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/IngredientVersionRead}
     */
    updateIngredientVersion(ingredientId, id, ingredient, callback) {
      let postBody = ingredient;
      // verify the required parameter 'ingredientId' is set
      if (ingredientId === undefined || ingredientId === null) {
        throw new Error("Missing the required parameter 'ingredientId' when calling updateIngredientVersion");
      }
      // verify the required parameter 'id' is set
      if (id === undefined || id === null) {
        throw new Error("Missing the required parameter 'id' when calling updateIngredientVersion");
      }
      // verify the required parameter 'ingredient' is set
      if (ingredient === undefined || ingredient === null) {
        throw new Error("Missing the required parameter 'ingredient' when calling updateIngredientVersion");
      }

      let pathParams = {
        'ingredient_id': ingredientId,
        'id': id
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['oauth'];
      let contentTypes = ['application/json', 'text/html'];
      let accepts = ['application/json', 'text/html'];
      let returnType = IngredientVersionRead;
      return this.apiClient.callApi(
        '/ingredients/{ingredient_id}/versions/{id}', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the updateIngredientVersionOptions operation.
     * @callback module:api/VersionsApi~updateIngredientVersionOptionsCallback
     * @param {String} error Error message, if any.
     * @param {module:model/IngredientVersionRead} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Updates the Ingredient resource version options.
     * @param {String} ingredientId 
     * @param {String} id 
     * @param {Object} opts Optional parameters
     * @param {module:model/InlineObject10} opts.ingredient 
     * @param {module:api/VersionsApi~updateIngredientVersionOptionsCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/IngredientVersionRead}
     */
    updateIngredientVersionOptions(ingredientId, id, opts, callback) {
      opts = opts || {};
      let postBody = opts['ingredient'];
      // verify the required parameter 'ingredientId' is set
      if (ingredientId === undefined || ingredientId === null) {
        throw new Error("Missing the required parameter 'ingredientId' when calling updateIngredientVersionOptions");
      }
      // verify the required parameter 'id' is set
      if (id === undefined || id === null) {
        throw new Error("Missing the required parameter 'id' when calling updateIngredientVersionOptions");
      }

      let pathParams = {
        'ingredient_id': ingredientId,
        'id': id
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['oauth'];
      let contentTypes = ['application/json', 'text/html'];
      let accepts = ['application/json', 'text/html'];
      let returnType = IngredientVersionRead;
      return this.apiClient.callApi(
        '/ingredients/{ingredient_id}/versions/{id}/options', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the updateProductVersion operation.
     * @callback module:api/VersionsApi~updateProductVersionCallback
     * @param {String} error Error message, if any.
     * @param {module:model/ProductVersionRead} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Replaces the Product resource version.
     * @param {String} productId 
     * @param {String} id 
     * @param {module:model/ProductVersionWrite} product Required properties are: * title  Rich-text properties are: * lead * claim * preparation * body  For usage of extended attributes, see detailed instructions in the `[POST] /attributes/{entity}` endpoint of the `AttributeDefinition` section. 
     * @param {module:api/VersionsApi~updateProductVersionCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/ProductVersionRead}
     */
    updateProductVersion(productId, id, product, callback) {
      let postBody = product;
      // verify the required parameter 'productId' is set
      if (productId === undefined || productId === null) {
        throw new Error("Missing the required parameter 'productId' when calling updateProductVersion");
      }
      // verify the required parameter 'id' is set
      if (id === undefined || id === null) {
        throw new Error("Missing the required parameter 'id' when calling updateProductVersion");
      }
      // verify the required parameter 'product' is set
      if (product === undefined || product === null) {
        throw new Error("Missing the required parameter 'product' when calling updateProductVersion");
      }

      let pathParams = {
        'product_id': productId,
        'id': id
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['oauth'];
      let contentTypes = ['application/json', 'text/html'];
      let accepts = ['application/json', 'text/html'];
      let returnType = ProductVersionRead;
      return this.apiClient.callApi(
        '/products/{product_id}/versions/{id}', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the updateProductVersionOptions operation.
     * @callback module:api/VersionsApi~updateProductVersionOptionsCallback
     * @param {String} error Error message, if any.
     * @param {module:model/ProductVersionRead} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Updates the Product resource version options.
     * @param {String} productId 
     * @param {String} id 
     * @param {Object} opts Optional parameters
     * @param {module:model/InlineObject14} opts.product 
     * @param {module:api/VersionsApi~updateProductVersionOptionsCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/ProductVersionRead}
     */
    updateProductVersionOptions(productId, id, opts, callback) {
      opts = opts || {};
      let postBody = opts['product'];
      // verify the required parameter 'productId' is set
      if (productId === undefined || productId === null) {
        throw new Error("Missing the required parameter 'productId' when calling updateProductVersionOptions");
      }
      // verify the required parameter 'id' is set
      if (id === undefined || id === null) {
        throw new Error("Missing the required parameter 'id' when calling updateProductVersionOptions");
      }

      let pathParams = {
        'product_id': productId,
        'id': id
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['oauth'];
      let contentTypes = ['application/json', 'text/html'];
      let accepts = ['application/json', 'text/html'];
      let returnType = ProductVersionRead;
      return this.apiClient.callApi(
        '/products/{product_id}/versions/{id}/options', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the updateRecipeVersion operation.
     * @callback module:api/VersionsApi~updateRecipeVersionCallback
     * @param {String} error Error message, if any.
     * @param {module:model/RecipeVersionRead} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Replaces the Recipe resource version.
     * @param {String} recipeId 
     * @param {String} id 
     * @param {module:model/RecipeVersionWrite} recipe Required properties are: * title  Rich-text properties are: * lead * advice * serving  For usage of extended attributes, see detailed instructions in the `[POST] /attributes/{entity}` endpoint of the `AttributeDefinition` section. 
     * @param {module:api/VersionsApi~updateRecipeVersionCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/RecipeVersionRead}
     */
    updateRecipeVersion(recipeId, id, recipe, callback) {
      let postBody = recipe;
      // verify the required parameter 'recipeId' is set
      if (recipeId === undefined || recipeId === null) {
        throw new Error("Missing the required parameter 'recipeId' when calling updateRecipeVersion");
      }
      // verify the required parameter 'id' is set
      if (id === undefined || id === null) {
        throw new Error("Missing the required parameter 'id' when calling updateRecipeVersion");
      }
      // verify the required parameter 'recipe' is set
      if (recipe === undefined || recipe === null) {
        throw new Error("Missing the required parameter 'recipe' when calling updateRecipeVersion");
      }

      let pathParams = {
        'recipe_id': recipeId,
        'id': id
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['oauth'];
      let contentTypes = ['application/json', 'text/html'];
      let accepts = ['application/json', 'text/html'];
      let returnType = RecipeVersionRead;
      return this.apiClient.callApi(
        '/recipes/{recipe_id}/versions/{id}', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the updateRecipeVersionOptions operation.
     * @callback module:api/VersionsApi~updateRecipeVersionOptionsCallback
     * @param {String} error Error message, if any.
     * @param {module:model/RecipeVersionRead} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Updates the Recipe resource version options.
     * @param {String} recipeId 
     * @param {String} id 
     * @param {Object} opts Optional parameters
     * @param {module:model/InlineObject18} opts.recipe 
     * @param {module:api/VersionsApi~updateRecipeVersionOptionsCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/RecipeVersionRead}
     */
    updateRecipeVersionOptions(recipeId, id, opts, callback) {
      opts = opts || {};
      let postBody = opts['recipe'];
      // verify the required parameter 'recipeId' is set
      if (recipeId === undefined || recipeId === null) {
        throw new Error("Missing the required parameter 'recipeId' when calling updateRecipeVersionOptions");
      }
      // verify the required parameter 'id' is set
      if (id === undefined || id === null) {
        throw new Error("Missing the required parameter 'id' when calling updateRecipeVersionOptions");
      }

      let pathParams = {
        'recipe_id': recipeId,
        'id': id
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['oauth'];
      let contentTypes = ['application/json', 'text/html'];
      let accepts = ['application/json', 'text/html'];
      let returnType = RecipeVersionRead;
      return this.apiClient.callApi(
        '/recipes/{recipe_id}/versions/{id}/options', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the updateVideoVersion operation.
     * @callback module:api/VersionsApi~updateVideoVersionCallback
     * @param {String} error Error message, if any.
     * @param {module:model/VideoVersionRead} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Replaces the Video resource version.
     * @param {String} videoId 
     * @param {String} id 
     * @param {module:model/VideoVersionWrite} video Rich-text properties are: * description  For usage of extended attributes, see detailed instructions in the `[POST] /attributes/{entity}` endpoint of the `AttributeDefinition` section. 
     * @param {module:api/VersionsApi~updateVideoVersionCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/VideoVersionRead}
     */
    updateVideoVersion(videoId, id, video, callback) {
      let postBody = video;
      // verify the required parameter 'videoId' is set
      if (videoId === undefined || videoId === null) {
        throw new Error("Missing the required parameter 'videoId' when calling updateVideoVersion");
      }
      // verify the required parameter 'id' is set
      if (id === undefined || id === null) {
        throw new Error("Missing the required parameter 'id' when calling updateVideoVersion");
      }
      // verify the required parameter 'video' is set
      if (video === undefined || video === null) {
        throw new Error("Missing the required parameter 'video' when calling updateVideoVersion");
      }

      let pathParams = {
        'video_id': videoId,
        'id': id
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['oauth'];
      let contentTypes = ['application/json', 'text/html'];
      let accepts = ['application/json', 'text/html'];
      let returnType = VideoVersionRead;
      return this.apiClient.callApi(
        '/videos/{video_id}/versions/{id}', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the updateVideoVersionOptions operation.
     * @callback module:api/VersionsApi~updateVideoVersionOptionsCallback
     * @param {String} error Error message, if any.
     * @param {module:model/VideoVersionRead} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Updates the Video resource version options.
     * @param {String} videoId 
     * @param {String} id 
     * @param {Object} opts Optional parameters
     * @param {module:model/InlineObject27} opts.video 
     * @param {module:api/VersionsApi~updateVideoVersionOptionsCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/VideoVersionRead}
     */
    updateVideoVersionOptions(videoId, id, opts, callback) {
      opts = opts || {};
      let postBody = opts['video'];
      // verify the required parameter 'videoId' is set
      if (videoId === undefined || videoId === null) {
        throw new Error("Missing the required parameter 'videoId' when calling updateVideoVersionOptions");
      }
      // verify the required parameter 'id' is set
      if (id === undefined || id === null) {
        throw new Error("Missing the required parameter 'id' when calling updateVideoVersionOptions");
      }

      let pathParams = {
        'video_id': videoId,
        'id': id
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['oauth'];
      let contentTypes = ['application/json', 'text/html'];
      let accepts = ['application/json', 'text/html'];
      let returnType = VideoVersionRead;
      return this.apiClient.callApi(
        '/videos/{video_id}/versions/{id}/options', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }


}
